"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[97103],{

/***/ 225956:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Icon": function() { return /* reexport */ Icon; },
  "LIST_ICONS": function() { return /* binding */ LIST_ICONS; }
});

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@tempi-icons-virtual-6cb7d71704/0/cache/@tempi-icons-npm-1.6.1-UX4BUYER-8801.0-ca37e8c69f-e623acf0ec.zip/node_modules/@tempi/icons/dist/mapping.es.js
const ICON_PROP_KEY = {
  AddAlternativeOutlined: "AddAlternativeOutlined",
  ClockAlternativeOutlined: "ClockAlternativeOutlined",
  DirectionAlternativeOutlined: "DirectionAlternativeOutlined",
  FavouriteAlternativeOutlined: "FavouriteAlternativeOutlined",
  FormScaleAlternativeOutlined: "FormScaleAlternativeOutlined",
  HomepageAlternativeOutlined: "HomepageAlternativeOutlined",
  LaptopAlternativeOutlined: "LaptopAlternativeOutlined",
  MarkAsReadAlternativeOutlined: "MarkAsReadAlternativeOutlined",
  RatingAlternativeOutlined: "RatingAlternativeOutlined",
  SettingAlternativeOutlined: "SettingAlternativeOutlined",
  SuccessAlternativeOutlined: "SuccessAlternativeOutlined",
  AccordionOutlined: "AccordionOutlined",
  AccountOutlined: "AccountOutlined",
  AddItemOutlined: "AddItemOutlined",
  AddOutlined: "AddOutlined",
  AdvisoryOutlined: "AdvisoryOutlined",
  AlignCenterOutlined: "AlignCenterOutlined",
  AlignJustifyOutlined: "AlignJustifyOutlined",
  AlignLeftOutlined: "AlignLeftOutlined",
  AlignRightOutlined: "AlignRightOutlined",
  AlignBottomSpaceOutlined: "AlignBottomSpaceOutlined",
  AlignHorizontalSpaceOutlined: "AlignHorizontalSpaceOutlined",
  AlignLeftSpaceOutlined: "AlignLeftSpaceOutlined",
  AlignRightSpaceOutlined: "AlignRightSpaceOutlined",
  AlignTopSpaceOutlined: "AlignTopSpaceOutlined",
  AlignVerticalSpaceOutlined: "AlignVerticalSpaceOutlined",
  ArrowUpOutlined: "ArrowUpOutlined",
  BackToTopOutlined: "BackToTopOutlined",
  BackOutlined: "BackOutlined",
  BagCheckmarkOutlined: "BagCheckmarkOutlined",
  BlockGroupOutlined: "BlockGroupOutlined",
  BoldOutlined: "BoldOutlined",
  BookOutlined: "BookOutlined",
  BoxOutlined: "BoxOutlined",
  BuildPcOutlined: "BuildPcOutlined",
  BulletedListOutlined: "BulletedListOutlined",
  BusinessCustomerOutlined: "BusinessCustomerOutlined",
  BusinessSolutionOutlined: "BusinessSolutionOutlined",
  ButtonOutlined: "ButtonOutlined",
  CalculatorOutlined: "CalculatorOutlined",
  CalendarOutlined: "CalendarOutlined",
  CalendarWorkForWeekOutlined: "CalendarWorkForWeekOutlined",
  CameraOutlined: "CameraOutlined",
  CartOutlined: "CartOutlined",
  CartPlusOutlined: "CartPlusOutlined",
  CartPlusFiveOutlined: "CartPlusFiveOutlined",
  CartPlusFourOutlined: "CartPlusFourOutlined",
  CartPlusThreeOutlined: "CartPlusThreeOutlined",
  CartPlusTwoOutlined: "CartPlusTwoOutlined",
  CashOutlined: "CashOutlined",
  CautionOutlined: "CautionOutlined",
  ChatOutlined: "ChatOutlined",
  CheckOutlined: "CheckOutlined",
  ChecklistOutlined: "ChecklistOutlined",
  ChevronDownOutlined: "ChevronDownOutlined",
  ChevronUpOutlined: "ChevronUpOutlined",
  ChipOutlined: "ChipOutlined",
  CircleBackOutlined: "CircleBackOutlined",
  CircleDownOutlined: "CircleDownOutlined",
  CircleForwardOutlined: "CircleForwardOutlined",
  CircleUpOutlined: "CircleUpOutlined",
  CloseOutlined: "CloseOutlined",
  CloudArrowUpOutlined: "CloudArrowUpOutlined",
  CodeOutlined: "CodeOutlined",
  ColorSwitchOutlined: "ColorSwitchOutlined",
  ContentSettingsOutlined: "ContentSettingsOutlined",
  CopyOutlined: "CopyOutlined",
  CustomerSupportOutlined: "CustomerSupportOutlined",
  DataTreemapOutlined: "DataTreemapOutlined",
  DeleteOutlined: "DeleteOutlined",
  DeleteColumnOutlined: "DeleteColumnOutlined",
  DeleteRowOutlined: "DeleteRowOutlined",
  DesktopOutlined: "DesktopOutlined",
  DinoOutlined: "DinoOutlined",
  DiscordOutlined: "DiscordOutlined",
  DiscountTagOutlined: "DiscountTagOutlined",
  DiscountOutlined: "DiscountOutlined",
  DividerOutlined: "DividerOutlined",
  DocumentOutlined: "DocumentOutlined",
  DotOutlined: "DotOutlined",
  DownLineOutlined: "DownLineOutlined",
  DownOutlined: "DownOutlined",
  DownloadOutlined: "DownloadOutlined",
  DownloadLightOutlined: "DownloadLightOutlined",
  DragOutlined: "DragOutlined",
  DragdropOutlined: "DragdropOutlined",
  DuplicateOutlined: "DuplicateOutlined",
  EditColumnOutlined: "EditColumnOutlined",
  EditSquareOutlined: "EditSquareOutlined",
  EditOutlined: "EditOutlined",
  EndShiftOutlined: "EndShiftOutlined",
  ExportFileOutlined: "ExportFileOutlined",
  EyeOutlined: "EyeOutlined",
  FaceIdOutlined: "FaceIdOutlined",
  FileOutlined: "FileOutlined",
  FillColorShapeOutlined: "FillColorShapeOutlined",
  FillColorTextOutlined: "FillColorTextOutlined",
  FilterOutlined: "FilterOutlined",
  FingerPrintOutlined: "FingerPrintOutlined",
  FluentButtonOutlined: "FluentButtonOutlined",
  FluentLinkOutlined: "FluentLinkOutlined",
  FormOutlined: "FormOutlined",
  FormatTextLeftOutlined: "FormatTextLeftOutlined",
  FormatTextRightOutlined: "FormatTextRightOutlined",
  ForwardOutlined: "ForwardOutlined",
  FourPointSpacingOutlined: "FourPointSpacingOutlined",
  GamingOutlined: "GamingOutlined",
  GarbageOutlined: "GarbageOutlined",
  GoldOutlined: "GoldOutlined",
  GuaranteeCheckedOutlined: "GuaranteeCheckedOutlined",
  HamburgerOutlined: "HamburgerOutlined",
  HeaderOutlined: "HeaderOutlined",
  HeadingOutlined: "HeadingOutlined",
  HeadphoneOutlined: "HeadphoneOutlined",
  HideOutlined: "HideOutlined",
  HOneOutlined: "HOneOutlined",
  HThreeOutlined: "HThreeOutlined",
  HTwoOutlined: "HTwoOutlined",
  IdCardOutlined: "IdCardOutlined",
  ImageOutlined: "ImageOutlined",
  InforOutlined: "InforOutlined",
  InsertColumnAfterOutlined: "InsertColumnAfterOutlined",
  InsertColumnBeforeOutlined: "InsertColumnBeforeOutlined",
  InsertRowAboveOutlined: "InsertRowAboveOutlined",
  InsertRowBelowOutlined: "InsertRowBelowOutlined",
  InstallmentOutlined: "InstallmentOutlined",
  InstallmentCalendarOutlined: "InstallmentCalendarOutlined",
  InternetOutlined: "InternetOutlined",
  ItalicOutlined: "ItalicOutlined",
  JumpForwardOutlined: "JumpForwardOutlined",
  JumpBackOutlined: "JumpBackOutlined",
  JumpForwardAlternativeOutlined: "JumpForwardAlternativeOutlined",
  LeftLineOutlined: "LeftLineOutlined",
  LeftOutlined: "LeftOutlined",
  LineOutlined: "LineOutlined",
  LineDashedOutlined: "LineDashedOutlined",
  LineDottedOutlined: "LineDottedOutlined",
  LineThroughOutlined: "LineThroughOutlined",
  LinkOutlined: "LinkOutlined",
  ListLocationOutlined: "ListLocationOutlined",
  ListOutlined: "ListOutlined",
  LocationOutlined: "LocationOutlined",
  LockOutlined: "LockOutlined",
  LogOutOutlined: "LogOutOutlined",
  LoyaltyOutlined: "LoyaltyOutlined",
  MailOutlined: "MailOutlined",
  MenuOutlined: "MenuOutlined",
  MinusCircleOutlined: "MinusCircleOutlined",
  MinusRetangleOutlined: "MinusRetangleOutlined",
  MinusOutlined: "MinusOutlined",
  MobileAndDesktopOutlined: "MobileAndDesktopOutlined",
  MobiphoneOutlined: "MobiphoneOutlined",
  MoneyTransferOutlined: "MoneyTransferOutlined",
  MonitorOutlined: "MonitorOutlined",
  MoreInforOutlined: "MoreInforOutlined",
  MoreProductOutlined: "MoreProductOutlined",
  NewsOutlined: "NewsOutlined",
  NoneOutlined: "NoneOutlined",
  NotFoundOutlined: "NotFoundOutlined",
  NotificationsOutlined: "NotificationsOutlined",
  NumberedListOutlined: "NumberedListOutlined",
  OrderOutlined: "OrderOutlined",
  PageOutlined: "PageOutlined",
  ParagraphOutlined: "ParagraphOutlined",
  PauseOutlined: "PauseOutlined",
  PauseIconOutlined: "PauseIconOutlined",
  PaymentOutlined: "PaymentOutlined",
  PbArrowLeftOutlined: "PbArrowLeftOutlined",
  PbLinkOutlined: "PbLinkOutlined",
  PbUnlinkOutlined: "PbUnlinkOutlined",
  PcOutlined: "PcOutlined",
  PhoneOutlined: "PhoneOutlined",
  PlayOutlined: "PlayOutlined",
  PlayBadgeOutlineOutlined: "PlayBadgeOutlineOutlined",
  PlayBoldOutlineOutlined: "PlayBoldOutlineOutlined",
  PlayCircleBoldOutlineOutlined: "PlayCircleBoldOutlineOutlined",
  PlayCircleOutlineOutlined: "PlayCircleOutlineOutlined",
  PlayRoundedSquareOutlineOutlined: "PlayRoundedSquareOutlineOutlined",
  PlusCircleOutlined: "PlusCircleOutlined",
  PlusRetangleOutlined: "PlusRetangleOutlined",
  PopupOutlined: "PopupOutlined",
  PrinterOutlined: "PrinterOutlined",
  ProductOutlined: "ProductOutlined",
  ProfileOutlined: "ProfileOutlined",
  PromoOutlined: "PromoOutlined",
  PromoDiscountOutlined: "PromoDiscountOutlined",
  QaOutlined: "QaOutlined",
  QrCodeScanOutlined: "QrCodeScanOutlined",
  RadiusBottomLeftOutlined: "RadiusBottomLeftOutlined",
  RadiusBottomRightOutlined: "RadiusBottomRightOutlined",
  RadiusUpLeftOutlined: "RadiusUpLeftOutlined",
  RadiusUpRightOutlined: "RadiusUpRightOutlined",
  RamOutlined: "RamOutlined",
  RedoOutlined: "RedoOutlined",
  RefreshOutlined: "RefreshOutlined",
  RefundOutlined: "RefundOutlined",
  ResizeSmallOutlined: "ResizeSmallOutlined",
  ReturnItemOutlined: "ReturnItemOutlined",
  RightLineOutlined: "RightLineOutlined",
  RightOutlined: "RightOutlined",
  RowTripleOutlined: "RowTripleOutlined",
  SaveOutlined: "SaveOutlined",
  ScalesOutlined: "ScalesOutlined",
  ScanningOutlined: "ScanningOutlined",
  SearchOutlined: "SearchOutlined",
  SelectedOutlined: "SelectedOutlined",
  SettingsOutlined: "SettingsOutlined",
  ShareOutlined: "ShareOutlined",
  ShieldOutlined: "ShieldOutlined",
  ShippingOutlined: "ShippingOutlined",
  ShopOutlined: "ShopOutlined",
  ShoppingCartOutlined: "ShoppingCartOutlined",
  ShortingOutlined: "ShortingOutlined",
  ShowOutlined: "ShowOutlined",
  ShowroomOutlined: "ShowroomOutlined",
  SlideTextOutlined: "SlideTextOutlined",
  SpacerOutlined: "SpacerOutlined",
  SpeakerOutlined: "SpeakerOutlined",
  SplitHorizontalOutlined: "SplitHorizontalOutlined",
  SquareMultipleOutlined: "SquareMultipleOutlined",
  StarEmphasisOutlined: "StarEmphasisOutlined",
  StopOutlined: "StopOutlined",
  SwitchOutlined: "SwitchOutlined",
  SyncOutlined: "SyncOutlined",
  TabOutlined: "TabOutlined",
  TableOutlined: "TableOutlined",
  TableCellEditOutlined: "TableCellEditOutlined",
  TableCellMergeOutlined: "TableCellMergeOutlined",
  TableCellSplitOutlined: "TableCellSplitOutlined",
  TableSettingOutlined: "TableSettingOutlined",
  TabletOutlined: "TabletOutlined",
  TelephoneOutlined: "TelephoneOutlined",
  TemplateOutlined: "TemplateOutlined",
  TestimonialOutlined: "TestimonialOutlined",
  TextOutlined: "TextOutlined",
  TextExpandOutlined: "TextExpandOutlined",
  TextUppercaseOutlined: "TextUppercaseOutlined",
  TiviOutlined: "TiviOutlined",
  TransactionHistoryOutlined: "TransactionHistoryOutlined",
  TrashBinDeleteRemoveOutlined: "TrashBinDeleteRemoveOutlined",
  TreeviewOutlined: "TreeviewOutlined",
  TvNewOutlined: "TvNewOutlined",
  TwoColumnsLayoutOutlined: "TwoColumnsLayoutOutlined",
  UncheckedCheckboxOutlined: "UncheckedCheckboxOutlined",
  UnderlineOutlined: "UnderlineOutlined",
  UndoOutlined: "UndoOutlined",
  UnionPaymentOutlined: "UnionPaymentOutlined",
  UnlinkOutlined: "UnlinkOutlined",
  UnlockOutlined: "UnlockOutlined",
  UpLineOutlined: "UpLineOutlined",
  UpOutlined: "UpOutlined",
  UploadOutlined: "UploadOutlined",
  VerticalLineOutlined: "VerticalLineOutlined",
  VideoClipOutlined: "VideoClipOutlined",
  VoucherOutlined: "VoucherOutlined",
  WarehouseOutlined: "WarehouseOutlined",
  WashingOutlined: "WashingOutlined",
  WebcamOutlined: "WebcamOutlined",
  AppListFilled: "AppListFilled",
  DirectionFilled: "DirectionFilled",
  AccountFilled: "AccountFilled",
  ArrowDownTinyFilled: "ArrowDownTinyFilled",
  ArrowDownFilled: "ArrowDownFilled",
  ArrowLeftTinyFilled: "ArrowLeftTinyFilled",
  ArrowLeftFilled: "ArrowLeftFilled",
  ArrowRightTinyFilled: "ArrowRightTinyFilled",
  ArrowRightFilled: "ArrowRightFilled",
  ArrowUpTinyFilled: "ArrowUpTinyFilled",
  ArrowUpFilled: "ArrowUpFilled",
  CalendarFilled: "CalendarFilled",
  CartFilled: "CartFilled",
  CartPlusFilled: "CartPlusFilled",
  CartPlusFiveFilled: "CartPlusFiveFilled",
  CartPlusFourFilled: "CartPlusFourFilled",
  CartPlusThreeFilled: "CartPlusThreeFilled",
  CartPlusTwoFilled: "CartPlusTwoFilled",
  CautionFilled: "CautionFilled",
  ChevronDownFilled: "ChevronDownFilled",
  ChevronUpFilled: "ChevronUpFilled",
  ClockFilled: "ClockFilled",
  CopyFilled: "CopyFilled",
  DeleteCircleFilled: "DeleteCircleFilled",
  DeleteFilled: "DeleteFilled",
  DiscordFilled: "DiscordFilled",
  DiscountTagFilled: "DiscountTagFilled",
  DiscountFilled: "DiscountFilled",
  DismissCircleFilled: "DismissCircleFilled",
  DoubleArrowTinyFilled: "DoubleArrowTinyFilled",
  DoubleArrowFilled: "DoubleArrowFilled",
  EditFilled: "EditFilled",
  EightFilled: "EightFilled",
  EyeHideFilled: "EyeHideFilled",
  EyeShowFilled: "EyeShowFilled",
  FacebookMessengerFilled: "FacebookMessengerFilled",
  FacebookFilled: "FacebookFilled",
  FavouriteFilled: "FavouriteFilled",
  FilterFilled: "FilterFilled",
  FiveFilled: "FiveFilled",
  FlashSaleFilled: "FlashSaleFilled",
  FlashOffFilled: "FlashOffFilled",
  FlashOnFilled: "FlashOnFilled",
  FourFilled: "FourFilled",
  FourColumnsDevFilled: "FourColumnsDevFilled",
  GarbageFilled: "GarbageFilled",
  GithubFilled: "GithubFilled",
  GlobalFilled: "GlobalFilled",
  GoogleFilled: "GoogleFilled",
  HighlightBackgroundFilled: "HighlightBackgroundFilled",
  HomepageFilled: "HomepageFilled",
  ImageFilled: "ImageFilled",
  InforFilled: "InforFilled",
  InstagramFilled: "InstagramFilled",
  LayerFilled: "LayerFilled",
  LeftAndRightSidebarDevFilled: "LeftAndRightSidebarDevFilled",
  LeftSidebarDevFilled: "LeftSidebarDevFilled",
  MoreProductFilled: "MoreProductFilled",
  NineFilled: "NineFilled",
  NotificationFilled: "NotificationFilled",
  NumberCounterFilled: "NumberCounterFilled",
  OneFilled: "OneFilled",
  OneColumnDevFilled: "OneColumnDevFilled",
  OptionsFilled: "OptionsFilled",
  OrderFilled: "OrderFilled",
  PbCallFilled: "PbCallFilled",
  PbInpageLinkFilled: "PbInpageLinkFilled",
  PbMailFilled: "PbMailFilled",
  PbNavigationCurvedFilled: "PbNavigationCurvedFilled",
  PbNavigationRoundFilled: "PbNavigationRoundFilled",
  PbPaginationDotBigFilled: "PbPaginationDotBigFilled",
  PbPaginationDotLineFilled: "PbPaginationDotLineFilled",
  PbPaginationDotsFilled: "PbPaginationDotsFilled",
  PbPaginationLineFilled: "PbPaginationLineFilled",
  PbSliderOneRowFilled: "PbSliderOneRowFilled",
  PbSliderThreeRowFilled: "PbSliderThreeRowFilled",
  PbSliderTwoRowFilled: "PbSliderTwoRowFilled",
  PhoneFilled: "PhoneFilled",
  PlayBadgeFillFilled: "PlayBadgeFillFilled",
  PlayCircleFillFilled: "PlayCircleFillFilled",
  PlayRoundedFillFilled: "PlayRoundedFillFilled",
  PlaySharpFillFilled: "PlaySharpFillFilled",
  PlaySquareFillFilled: "PlaySquareFillFilled",
  ProfileFilled: "ProfileFilled",
  PromoFilled: "PromoFilled",
  RatingFilled: "RatingFilled",
  RightSidebarDevFilled: "RightSidebarDevFilled",
  SaveFilled: "SaveFilled",
  SettingsFilled: "SettingsFilled",
  SevenFilled: "SevenFilled",
  SixFilled: "SixFilled",
  SixColumnDevFilled: "SixColumnDevFilled",
  SliderFilled: "SliderFilled",
  SuccessFilled: "SuccessFilled",
  TenFilled: "TenFilled",
  ThreeFilled: "ThreeFilled",
  ThreeColumnsDevFilled: "ThreeColumnsDevFilled",
  TickFilled: "TickFilled",
  TiktokFilled: "TiktokFilled",
  TwitterFilled: "TwitterFilled",
  TwoFilled: "TwoFilled",
  TwoColumnsFilled: "TwoColumnsFilled",
  TwoColumnsDevFilled: "TwoColumnsDevFilled",
  TwoSmallColumnLeftDevFilled: "TwoSmallColumnLeftDevFilled",
  TwoSmallColumnRightDevFilled: "TwoSmallColumnRightDevFilled",
  VerticalLineFilled: "VerticalLineFilled",
  VoucherFilled: "VoucherFilled",
  WarningFilled: "WarningFilled",
  YoutubeFilled: "YoutubeFilled",
  ZaloFilled: "ZaloFilled",
  ApiCodeColored: "ApiCodeColored",
  AtmCardColored: "AtmCardColored",
  AtmColored: "AtmColored",
  BadgesColored: "BadgesColored",
  BankColored: "BankColored",
  CashColored: "CashColored",
  CircleBankColored: "CircleBankColored",
  CircleCashColored: "CircleCashColored",
  CircleMobileBankingColored: "CircleMobileBankingColored",
  CircleQrCodeColored: "CircleQrCodeColored",
  CircleShippingColored: "CircleShippingColored",
  CircleShowroomColored: "CircleShowroomColored",
  CircleVisaLogoColored: "CircleVisaLogoColored",
  DeleteCircleColored: "DeleteCircleColored",
  DinoColored: "DinoColored",
  DiscountTagColored: "DiscountTagColored",
  DoubleStarColored: "DoubleStarColored",
  FacebookColored: "FacebookColored",
  FireFlashsaleColored: "FireFlashsaleColored",
  FreeShippingColored: "FreeShippingColored",
  GoogleSheetColored: "GoogleSheetColored",
  GoogleGmailColored: "GoogleGmailColored",
  GuaranteeCheckedColored: "GuaranteeCheckedColored",
  IndicatorColored: "IndicatorColored",
  InstagramColored: "InstagramColored",
  LuckyDrawColored: "LuckyDrawColored",
  LuckySpinColored: "LuckySpinColored",
  MasterCardColored: "MasterCardColored",
  MobileBankingColored: "MobileBankingColored",
  PaymentColored: "PaymentColored",
  PvShowroomColored: "PvShowroomColored",
  QrCodeColored: "QrCodeColored",
  RewardGoldenColored: "RewardGoldenColored",
  RewardBronzeCircleColored: "RewardBronzeCircleColored",
  RewardBronzeColored: "RewardBronzeColored",
  RewardGoldenCircleColored: "RewardGoldenCircleColored",
  RewardPlatinumCircleColored: "RewardPlatinumCircleColored",
  RewardPlatinumColored: "RewardPlatinumColored",
  RewardSilverCircleColored: "RewardSilverCircleColored",
  RewardSilverColored: "RewardSilverColored",
  SaleColored: "SaleColored",
  ShippingColored: "ShippingColored",
  ShopColored: "ShopColored",
  ShoppingCartColored: "ShoppingCartColored",
  StarColored: "StarColored",
  SuccessColored: "SuccessColored",
  UsaColored: "UsaColored",
  VietnamColored: "VietnamColored",
  VisaCardColored: "VisaCardColored",
  VisaLogoColored: "VisaLogoColored",
  VnPayColored: "VnPayColored",
  VoucherColored: "VoucherColored",
  WalletColored: "WalletColored",
  AcFlags: "AcFlags",
  AdFlags: "AdFlags",
  AeFlags: "AeFlags",
  AfFlags: "AfFlags",
  AgFlags: "AgFlags",
  AiFlags: "AiFlags",
  AlFlags: "AlFlags",
  AmFlags: "AmFlags",
  AoFlags: "AoFlags",
  AqFlags: "AqFlags",
  ArFlags: "ArFlags",
  AsFlags: "AsFlags",
  AtFlags: "AtFlags",
  AuFlags: "AuFlags",
  AwFlags: "AwFlags",
  AxFlags: "AxFlags",
  AzFlags: "AzFlags",
  BaFlags: "BaFlags",
  BbFlags: "BbFlags",
  BdFlags: "BdFlags",
  BeFlags: "BeFlags",
  BfFlags: "BfFlags",
  BgFlags: "BgFlags",
  BhFlags: "BhFlags",
  BiFlags: "BiFlags",
  BjFlags: "BjFlags",
  BlFlags: "BlFlags",
  BmFlags: "BmFlags",
  BnFlags: "BnFlags",
  BoFlags: "BoFlags",
  BqFlags: "BqFlags",
  BrFlags: "BrFlags",
  BsFlags: "BsFlags",
  BtFlags: "BtFlags",
  BvFlags: "BvFlags",
  BwFlags: "BwFlags",
  ByFlags: "ByFlags",
  BzFlags: "BzFlags",
  CaFlags: "CaFlags",
  CcFlags: "CcFlags",
  CdFlags: "CdFlags",
  CfFlags: "CfFlags",
  CgFlags: "CgFlags",
  ChFlags: "ChFlags",
  CiFlags: "CiFlags",
  CkFlags: "CkFlags",
  ClFlags: "ClFlags",
  CmFlags: "CmFlags",
  CnFlags: "CnFlags",
  CoFlags: "CoFlags",
  CrFlags: "CrFlags",
  CuFlags: "CuFlags",
  CvFlags: "CvFlags",
  CwFlags: "CwFlags",
  CxFlags: "CxFlags",
  CyFlags: "CyFlags",
  CzFlags: "CzFlags",
  DeFlags: "DeFlags",
  DjFlags: "DjFlags",
  DkFlags: "DkFlags",
  DmFlags: "DmFlags",
  DoFlags: "DoFlags",
  DzFlags: "DzFlags",
  EcFlags: "EcFlags",
  EeFlags: "EeFlags",
  EgFlags: "EgFlags",
  EhFlags: "EhFlags",
  ErFlags: "ErFlags",
  EsFlags: "EsFlags",
  EtFlags: "EtFlags",
  EuFlags: "EuFlags",
  FiFlags: "FiFlags",
  FjFlags: "FjFlags",
  FkFlags: "FkFlags",
  FmFlags: "FmFlags",
  FoFlags: "FoFlags",
  FrFlags: "FrFlags",
  GaFlags: "GaFlags",
  GbFlags: "GbFlags",
  GdFlags: "GdFlags",
  GeAbFlags: "GeAbFlags",
  GeOsFlags: "GeOsFlags",
  GeFlags: "GeFlags",
  GfFlags: "GfFlags",
  GgFlags: "GgFlags",
  GhFlags: "GhFlags",
  GiFlags: "GiFlags",
  GlFlags: "GlFlags",
  GmFlags: "GmFlags",
  GnFlags: "GnFlags",
  GpFlags: "GpFlags",
  GqFlags: "GqFlags",
  GrFlags: "GrFlags",
  GsFlags: "GsFlags",
  GtFlags: "GtFlags",
  GuFlags: "GuFlags",
  GwFlags: "GwFlags",
  GyFlags: "GyFlags",
  HkFlags: "HkFlags",
  HmFlags: "HmFlags",
  HnFlags: "HnFlags",
  HrFlags: "HrFlags",
  HtFlags: "HtFlags",
  HuFlags: "HuFlags",
  IcFlags: "IcFlags",
  IdFlags: "IdFlags",
  IeFlags: "IeFlags",
  IlFlags: "IlFlags",
  ImFlags: "ImFlags",
  InFlags: "InFlags",
  IoFlags: "IoFlags",
  IqFlags: "IqFlags",
  IrFlags: "IrFlags",
  IsFlags: "IsFlags",
  ItFlags: "ItFlags",
  JeFlags: "JeFlags",
  JmFlags: "JmFlags",
  JoFlags: "JoFlags",
  JpFlags: "JpFlags",
  KeFlags: "KeFlags",
  KgFlags: "KgFlags",
  KhFlags: "KhFlags",
  KiFlags: "KiFlags",
  KmFlags: "KmFlags",
  KnFlags: "KnFlags",
  KpFlags: "KpFlags",
  KrFlags: "KrFlags",
  KwFlags: "KwFlags",
  KyFlags: "KyFlags",
  KzFlags: "KzFlags",
  LaFlags: "LaFlags",
  LbFlags: "LbFlags",
  LcFlags: "LcFlags",
  LiFlags: "LiFlags",
  LkFlags: "LkFlags",
  LrFlags: "LrFlags",
  LsFlags: "LsFlags",
  LtFlags: "LtFlags",
  LuFlags: "LuFlags",
  LvFlags: "LvFlags",
  LyFlags: "LyFlags",
  MaFlags: "MaFlags",
  McFlags: "McFlags",
  MdFlags: "MdFlags",
  MeFlags: "MeFlags",
  MfFlags: "MfFlags",
  MgFlags: "MgFlags",
  MhFlags: "MhFlags",
  MkFlags: "MkFlags",
  MlFlags: "MlFlags",
  MmFlags: "MmFlags",
  MnFlags: "MnFlags",
  MoFlags: "MoFlags",
  MpFlags: "MpFlags",
  MqFlags: "MqFlags",
  MrFlags: "MrFlags",
  MsFlags: "MsFlags",
  MtFlags: "MtFlags",
  MuFlags: "MuFlags",
  MvFlags: "MvFlags",
  MwFlags: "MwFlags",
  MxFlags: "MxFlags",
  MyFlags: "MyFlags",
  MzFlags: "MzFlags",
  NaFlags: "NaFlags",
  NcFlags: "NcFlags",
  NeFlags: "NeFlags",
  NfFlags: "NfFlags",
  NgFlags: "NgFlags",
  NiFlags: "NiFlags",
  NlFlags: "NlFlags",
  NoFlags: "NoFlags",
  NpFlags: "NpFlags",
  NrFlags: "NrFlags",
  NuFlags: "NuFlags",
  NzFlags: "NzFlags",
  OmFlags: "OmFlags",
  PaFlags: "PaFlags",
  PeFlags: "PeFlags",
  PfFlags: "PfFlags",
  PgFlags: "PgFlags",
  PhFlags: "PhFlags",
  PkFlags: "PkFlags",
  PlFlags: "PlFlags",
  PmFlags: "PmFlags",
  PnFlags: "PnFlags",
  PrFlags: "PrFlags",
  PsFlags: "PsFlags",
  PtFlags: "PtFlags",
  PwFlags: "PwFlags",
  PyFlags: "PyFlags",
  QaFlags: "QaFlags",
  ReFlags: "ReFlags",
  RoFlags: "RoFlags",
  RsFlags: "RsFlags",
  RuFlags: "RuFlags",
  RwFlags: "RwFlags",
  SaFlags: "SaFlags",
  SbFlags: "SbFlags",
  ScFlags: "ScFlags",
  SdFlags: "SdFlags",
  SeFlags: "SeFlags",
  SgFlags: "SgFlags",
  ShFlags: "ShFlags",
  SiFlags: "SiFlags",
  SjFlags: "SjFlags",
  SkFlags: "SkFlags",
  SlFlags: "SlFlags",
  SmFlags: "SmFlags",
  SnFlags: "SnFlags",
  SoFlags: "SoFlags",
  SrFlags: "SrFlags",
  SsFlags: "SsFlags",
  StFlags: "StFlags",
  SvFlags: "SvFlags",
  SxFlags: "SxFlags",
  SyFlags: "SyFlags",
  SzFlags: "SzFlags",
  TaFlags: "TaFlags",
  TcFlags: "TcFlags",
  TdFlags: "TdFlags",
  TfFlags: "TfFlags",
  TgFlags: "TgFlags",
  ThFlags: "ThFlags",
  TjFlags: "TjFlags",
  TkFlags: "TkFlags",
  TlFlags: "TlFlags",
  TmFlags: "TmFlags",
  TnFlags: "TnFlags",
  ToFlags: "ToFlags",
  TrFlags: "TrFlags",
  TtFlags: "TtFlags",
  TvFlags: "TvFlags",
  TwFlags: "TwFlags",
  TzFlags: "TzFlags",
  UaFlags: "UaFlags",
  UgFlags: "UgFlags",
  UmFlags: "UmFlags",
  UsFlags: "UsFlags",
  UyFlags: "UyFlags",
  UzFlags: "UzFlags",
  VaFlags: "VaFlags",
  VcFlags: "VcFlags",
  VeFlags: "VeFlags",
  VgFlags: "VgFlags",
  ViFlags: "ViFlags",
  VnFlags: "VnFlags",
  VuFlags: "VuFlags",
  WfFlags: "WfFlags",
  WsFlags: "WsFlags",
  XkFlags: "XkFlags",
  YeFlags: "YeFlags",
  YtFlags: "YtFlags",
  ZaFlags: "ZaFlags",
  ZmFlags: "ZmFlags",
  ZwFlags: "ZwFlags"
};
const getIconUrl = async (name) => {
  switch (name) {
    case ICON_PROP_KEY.ApiCodeColored:
      return (await __webpack_require__.e(/* import() */ 31357).then(__webpack_require__.bind(__webpack_require__, 231357))).default;
    case ICON_PROP_KEY.AtmCardColored:
      return (await __webpack_require__.e(/* import() */ 34039).then(__webpack_require__.bind(__webpack_require__, 934039))).default;
    case ICON_PROP_KEY.AtmColored:
      return (await __webpack_require__.e(/* import() */ 7241).then(__webpack_require__.bind(__webpack_require__, 707241))).default;
    case ICON_PROP_KEY.BadgesColored:
      return (await __webpack_require__.e(/* import() */ 56222).then(__webpack_require__.bind(__webpack_require__, 356222))).default;
    case ICON_PROP_KEY.BankColored:
      return (await __webpack_require__.e(/* import() */ 27382).then(__webpack_require__.bind(__webpack_require__, 327382))).default;
    case ICON_PROP_KEY.CashColored:
      return (await __webpack_require__.e(/* import() */ 96948).then(__webpack_require__.bind(__webpack_require__, 396948))).default;
    case ICON_PROP_KEY.CircleBankColored:
      return (await __webpack_require__.e(/* import() */ 9654).then(__webpack_require__.bind(__webpack_require__, 309654))).default;
    case ICON_PROP_KEY.CircleCashColored:
      return (await __webpack_require__.e(/* import() */ 83158).then(__webpack_require__.bind(__webpack_require__, 283158))).default;
    case ICON_PROP_KEY.CircleMobileBankingColored:
      return (await __webpack_require__.e(/* import() */ 17720).then(__webpack_require__.bind(__webpack_require__, 517720))).default;
    case ICON_PROP_KEY.CircleQrCodeColored:
      return (await __webpack_require__.e(/* import() */ 32221).then(__webpack_require__.bind(__webpack_require__, 532221))).default;
    case ICON_PROP_KEY.CircleShippingColored:
      return (await __webpack_require__.e(/* import() */ 79890).then(__webpack_require__.bind(__webpack_require__, 779890))).default;
    case ICON_PROP_KEY.CircleShowroomColored:
      return (await __webpack_require__.e(/* import() */ 36662).then(__webpack_require__.bind(__webpack_require__, 136662))).default;
    case ICON_PROP_KEY.CircleVisaLogoColored:
      return (await __webpack_require__.e(/* import() */ 34704).then(__webpack_require__.bind(__webpack_require__, 934704))).default;
    case ICON_PROP_KEY.DeleteCircleColored:
      return (await __webpack_require__.e(/* import() */ 55367).then(__webpack_require__.bind(__webpack_require__, 155367))).default;
    case ICON_PROP_KEY.DinoColored:
      return (await __webpack_require__.e(/* import() */ 79387).then(__webpack_require__.bind(__webpack_require__, 479387))).default;
    case ICON_PROP_KEY.DiscountTagColored:
      return (await __webpack_require__.e(/* import() */ 95846).then(__webpack_require__.bind(__webpack_require__, 795846))).default;
    case ICON_PROP_KEY.DoubleStarColored:
      return (await __webpack_require__.e(/* import() */ 69737).then(__webpack_require__.bind(__webpack_require__, 369737))).default;
    case ICON_PROP_KEY.FacebookColored:
      return (await __webpack_require__.e(/* import() */ 319).then(__webpack_require__.bind(__webpack_require__, 300319))).default;
    case ICON_PROP_KEY.FireFlashsaleColored:
      return (await __webpack_require__.e(/* import() */ 2419).then(__webpack_require__.bind(__webpack_require__, 902419))).default;
    case ICON_PROP_KEY.FreeShippingColored:
      return (await __webpack_require__.e(/* import() */ 91157).then(__webpack_require__.bind(__webpack_require__, 791157))).default;
    case ICON_PROP_KEY.GoogleSheetColored:
      return (await __webpack_require__.e(/* import() */ 85957).then(__webpack_require__.bind(__webpack_require__, 985957))).default;
    case ICON_PROP_KEY.GoogleGmailColored:
      return (await __webpack_require__.e(/* import() */ 12391).then(__webpack_require__.bind(__webpack_require__, 612391))).default;
    case ICON_PROP_KEY.GuaranteeCheckedColored:
      return (await __webpack_require__.e(/* import() */ 57500).then(__webpack_require__.bind(__webpack_require__, 457500))).default;
    case ICON_PROP_KEY.IndicatorColored:
      return (await __webpack_require__.e(/* import() */ 89917).then(__webpack_require__.bind(__webpack_require__, 289917))).default;
    case ICON_PROP_KEY.InstagramColored:
      return (await __webpack_require__.e(/* import() */ 99274).then(__webpack_require__.bind(__webpack_require__, 99274))).default;
    case ICON_PROP_KEY.LuckyDrawColored:
      return (await __webpack_require__.e(/* import() */ 25526).then(__webpack_require__.bind(__webpack_require__, 825526))).default;
    case ICON_PROP_KEY.LuckySpinColored:
      return (await __webpack_require__.e(/* import() */ 38004).then(__webpack_require__.bind(__webpack_require__, 638004))).default;
    case ICON_PROP_KEY.MasterCardColored:
      return (await __webpack_require__.e(/* import() */ 30339).then(__webpack_require__.bind(__webpack_require__, 330339))).default;
    case ICON_PROP_KEY.MobileBankingColored:
      return (await __webpack_require__.e(/* import() */ 77868).then(__webpack_require__.bind(__webpack_require__, 377868))).default;
    case ICON_PROP_KEY.PaymentColored:
      return (await __webpack_require__.e(/* import() */ 44987).then(__webpack_require__.bind(__webpack_require__, 344987))).default;
    case ICON_PROP_KEY.PvShowroomColored:
      return (await __webpack_require__.e(/* import() */ 86921).then(__webpack_require__.bind(__webpack_require__, 286921))).default;
    case ICON_PROP_KEY.QrCodeColored:
      return (await __webpack_require__.e(/* import() */ 10839).then(__webpack_require__.bind(__webpack_require__, 810839))).default;
    case ICON_PROP_KEY.RewardGoldenColored:
      return (await __webpack_require__.e(/* import() */ 28356).then(__webpack_require__.bind(__webpack_require__, 828356))).default;
    case ICON_PROP_KEY.RewardBronzeCircleColored:
      return (await __webpack_require__.e(/* import() */ 4066).then(__webpack_require__.bind(__webpack_require__, 204066))).default;
    case ICON_PROP_KEY.RewardBronzeColored:
      return (await __webpack_require__.e(/* import() */ 65481).then(__webpack_require__.bind(__webpack_require__, 765481))).default;
    case ICON_PROP_KEY.RewardGoldenCircleColored:
      return (await __webpack_require__.e(/* import() */ 94813).then(__webpack_require__.bind(__webpack_require__, 94813))).default;
    case ICON_PROP_KEY.RewardPlatinumCircleColored:
      return (await __webpack_require__.e(/* import() */ 50879).then(__webpack_require__.bind(__webpack_require__, 950879))).default;
    case ICON_PROP_KEY.RewardPlatinumColored:
      return (await __webpack_require__.e(/* import() */ 80497).then(__webpack_require__.bind(__webpack_require__, 680497))).default;
    case ICON_PROP_KEY.RewardSilverCircleColored:
      return (await __webpack_require__.e(/* import() */ 96770).then(__webpack_require__.bind(__webpack_require__, 196770))).default;
    case ICON_PROP_KEY.RewardSilverColored:
      return (await __webpack_require__.e(/* import() */ 3068).then(__webpack_require__.bind(__webpack_require__, 503068))).default;
    case ICON_PROP_KEY.SaleColored:
      return (await __webpack_require__.e(/* import() */ 33865).then(__webpack_require__.bind(__webpack_require__, 933865))).default;
    case ICON_PROP_KEY.ShippingColored:
      return (await __webpack_require__.e(/* import() */ 23351).then(__webpack_require__.bind(__webpack_require__, 623351))).default;
    case ICON_PROP_KEY.ShopColored:
      return (await __webpack_require__.e(/* import() */ 29514).then(__webpack_require__.bind(__webpack_require__, 29514))).default;
    case ICON_PROP_KEY.ShoppingCartColored:
      return (await __webpack_require__.e(/* import() */ 19701).then(__webpack_require__.bind(__webpack_require__, 119701))).default;
    case ICON_PROP_KEY.StarColored:
      return (await __webpack_require__.e(/* import() */ 30490).then(__webpack_require__.bind(__webpack_require__, 530490))).default;
    case ICON_PROP_KEY.SuccessColored:
      return (await __webpack_require__.e(/* import() */ 42599).then(__webpack_require__.bind(__webpack_require__, 942599))).default;
    case ICON_PROP_KEY.UsaColored:
      return (await __webpack_require__.e(/* import() */ 55165).then(__webpack_require__.bind(__webpack_require__, 855165))).default;
    case ICON_PROP_KEY.VietnamColored:
      return (await __webpack_require__.e(/* import() */ 12322).then(__webpack_require__.bind(__webpack_require__, 212322))).default;
    case ICON_PROP_KEY.VisaCardColored:
      return (await __webpack_require__.e(/* import() */ 30201).then(__webpack_require__.bind(__webpack_require__, 330201))).default;
    case ICON_PROP_KEY.VisaLogoColored:
      return (await __webpack_require__.e(/* import() */ 67794).then(__webpack_require__.bind(__webpack_require__, 967794))).default;
    case ICON_PROP_KEY.VnPayColored:
      return (await __webpack_require__.e(/* import() */ 42620).then(__webpack_require__.bind(__webpack_require__, 442620))).default;
    case ICON_PROP_KEY.VoucherColored:
      return (await __webpack_require__.e(/* import() */ 4618).then(__webpack_require__.bind(__webpack_require__, 904618))).default;
    case ICON_PROP_KEY.WalletColored:
      return (await __webpack_require__.e(/* import() */ 62447).then(__webpack_require__.bind(__webpack_require__, 362447))).default;
    case ICON_PROP_KEY.AppListFilled:
      return (await __webpack_require__.e(/* import() */ 11368).then(__webpack_require__.bind(__webpack_require__, 511368))).default;
    case ICON_PROP_KEY.DirectionFilled:
      return (await __webpack_require__.e(/* import() */ 19560).then(__webpack_require__.bind(__webpack_require__, 419560))).default;
    case ICON_PROP_KEY.AccountFilled:
      return (await __webpack_require__.e(/* import() */ 69550).then(__webpack_require__.bind(__webpack_require__, 69550))).default;
    case ICON_PROP_KEY.ArrowDownTinyFilled:
      return (await __webpack_require__.e(/* import() */ 3585).then(__webpack_require__.bind(__webpack_require__, 903585))).default;
    case ICON_PROP_KEY.ArrowDownFilled:
      return (await __webpack_require__.e(/* import() */ 71629).then(__webpack_require__.bind(__webpack_require__, 171629))).default;
    case ICON_PROP_KEY.ArrowLeftTinyFilled:
      return (await __webpack_require__.e(/* import() */ 11066).then(__webpack_require__.bind(__webpack_require__, 737963))).default;
    case ICON_PROP_KEY.ArrowLeftFilled:
      return (await __webpack_require__.e(/* import() */ 73210).then(__webpack_require__.bind(__webpack_require__, 273210))).default;
    case ICON_PROP_KEY.ArrowRightTinyFilled:
      return (await __webpack_require__.e(/* import() */ 64581).then(__webpack_require__.bind(__webpack_require__, 564581))).default;
    case ICON_PROP_KEY.ArrowRightFilled:
      return (await __webpack_require__.e(/* import() */ 25109).then(__webpack_require__.bind(__webpack_require__, 525109))).default;
    case ICON_PROP_KEY.ArrowUpTinyFilled:
      return (await __webpack_require__.e(/* import() */ 33592).then(__webpack_require__.bind(__webpack_require__, 533592))).default;
    case ICON_PROP_KEY.ArrowUpFilled:
      return (await __webpack_require__.e(/* import() */ 33894).then(__webpack_require__.bind(__webpack_require__, 633894))).default;
    case ICON_PROP_KEY.CalendarFilled:
      return (await __webpack_require__.e(/* import() */ 1364).then(__webpack_require__.bind(__webpack_require__, 101364))).default;
    case ICON_PROP_KEY.CartFilled:
      return (await __webpack_require__.e(/* import() */ 22110).then(__webpack_require__.bind(__webpack_require__, 822110))).default;
    case ICON_PROP_KEY.CartPlusFilled:
      return (await __webpack_require__.e(/* import() */ 72803).then(__webpack_require__.bind(__webpack_require__, 372803))).default;
    case ICON_PROP_KEY.CartPlusFiveFilled:
      return (await __webpack_require__.e(/* import() */ 45417).then(__webpack_require__.bind(__webpack_require__, 145417))).default;
    case ICON_PROP_KEY.CartPlusFourFilled:
      return (await __webpack_require__.e(/* import() */ 89143).then(__webpack_require__.bind(__webpack_require__, 189143))).default;
    case ICON_PROP_KEY.CartPlusThreeFilled:
      return (await __webpack_require__.e(/* import() */ 35966).then(__webpack_require__.bind(__webpack_require__, 135966))).default;
    case ICON_PROP_KEY.CartPlusTwoFilled:
      return (await __webpack_require__.e(/* import() */ 34737).then(__webpack_require__.bind(__webpack_require__, 134737))).default;
    case ICON_PROP_KEY.CautionFilled:
      return (await __webpack_require__.e(/* import() */ 83590).then(__webpack_require__.bind(__webpack_require__, 983590))).default;
    case ICON_PROP_KEY.ChevronDownFilled:
      return (await __webpack_require__.e(/* import() */ 81443).then(__webpack_require__.bind(__webpack_require__, 81443))).default;
    case ICON_PROP_KEY.ChevronUpFilled:
      return (await __webpack_require__.e(/* import() */ 12883).then(__webpack_require__.bind(__webpack_require__, 312883))).default;
    case ICON_PROP_KEY.ClockFilled:
      return (await __webpack_require__.e(/* import() */ 21959).then(__webpack_require__.bind(__webpack_require__, 221959))).default;
    case ICON_PROP_KEY.CopyFilled:
      return (await __webpack_require__.e(/* import() */ 90458).then(__webpack_require__.bind(__webpack_require__, 390458))).default;
    case ICON_PROP_KEY.DeleteCircleFilled:
      return (await __webpack_require__.e(/* import() */ 48068).then(__webpack_require__.bind(__webpack_require__, 248068))).default;
    case ICON_PROP_KEY.DeleteFilled:
      return (await __webpack_require__.e(/* import() */ 49775).then(__webpack_require__.bind(__webpack_require__, 349775))).default;
    case ICON_PROP_KEY.DiscordFilled:
      return (await __webpack_require__.e(/* import() */ 33087).then(__webpack_require__.bind(__webpack_require__, 933087))).default;
    case ICON_PROP_KEY.DiscountTagFilled:
      return (await __webpack_require__.e(/* import() */ 45092).then(__webpack_require__.bind(__webpack_require__, 745092))).default;
    case ICON_PROP_KEY.DiscountFilled:
      return (await __webpack_require__.e(/* import() */ 12964).then(__webpack_require__.bind(__webpack_require__, 912964))).default;
    case ICON_PROP_KEY.DismissCircleFilled:
      return (await __webpack_require__.e(/* import() */ 47169).then(__webpack_require__.bind(__webpack_require__, 947169))).default;
    case ICON_PROP_KEY.DoubleArrowTinyFilled:
      return (await __webpack_require__.e(/* import() */ 60842).then(__webpack_require__.bind(__webpack_require__, 960842))).default;
    case ICON_PROP_KEY.DoubleArrowFilled:
      return (await __webpack_require__.e(/* import() */ 60904).then(__webpack_require__.bind(__webpack_require__, 160904))).default;
    case ICON_PROP_KEY.EditFilled:
      return (await __webpack_require__.e(/* import() */ 81904).then(__webpack_require__.bind(__webpack_require__, 381904))).default;
    case ICON_PROP_KEY.EightFilled:
      return (await __webpack_require__.e(/* import() */ 28494).then(__webpack_require__.bind(__webpack_require__, 328494))).default;
    case ICON_PROP_KEY.EyeHideFilled:
      return (await __webpack_require__.e(/* import() */ 58306).then(__webpack_require__.bind(__webpack_require__, 58306))).default;
    case ICON_PROP_KEY.EyeShowFilled:
      return (await __webpack_require__.e(/* import() */ 36813).then(__webpack_require__.bind(__webpack_require__, 736813))).default;
    case ICON_PROP_KEY.FacebookMessengerFilled:
      return (await __webpack_require__.e(/* import() */ 21125).then(__webpack_require__.bind(__webpack_require__, 621125))).default;
    case ICON_PROP_KEY.FacebookFilled:
      return (await __webpack_require__.e(/* import() */ 28773).then(__webpack_require__.bind(__webpack_require__, 628773))).default;
    case ICON_PROP_KEY.FavouriteFilled:
      return (await __webpack_require__.e(/* import() */ 37081).then(__webpack_require__.bind(__webpack_require__, 637081))).default;
    case ICON_PROP_KEY.FilterFilled:
      return (await __webpack_require__.e(/* import() */ 97504).then(__webpack_require__.bind(__webpack_require__, 797504))).default;
    case ICON_PROP_KEY.FiveFilled:
      return (await __webpack_require__.e(/* import() */ 98423).then(__webpack_require__.bind(__webpack_require__, 598423))).default;
    case ICON_PROP_KEY.FlashSaleFilled:
      return (await __webpack_require__.e(/* import() */ 62281).then(__webpack_require__.bind(__webpack_require__, 462281))).default;
    case ICON_PROP_KEY.FlashOffFilled:
      return (await __webpack_require__.e(/* import() */ 47633).then(__webpack_require__.bind(__webpack_require__, 447633))).default;
    case ICON_PROP_KEY.FlashOnFilled:
      return (await __webpack_require__.e(/* import() */ 9996).then(__webpack_require__.bind(__webpack_require__, 509996))).default;
    case ICON_PROP_KEY.FourFilled:
      return (await __webpack_require__.e(/* import() */ 68777).then(__webpack_require__.bind(__webpack_require__, 468777))).default;
    case ICON_PROP_KEY.FourColumnsDevFilled:
      return (await __webpack_require__.e(/* import() */ 85169).then(__webpack_require__.bind(__webpack_require__, 385169))).default;
    case ICON_PROP_KEY.GarbageFilled:
      return (await __webpack_require__.e(/* import() */ 12629).then(__webpack_require__.bind(__webpack_require__, 12629))).default;
    case ICON_PROP_KEY.GithubFilled:
      return (await __webpack_require__.e(/* import() */ 21423).then(__webpack_require__.bind(__webpack_require__, 821423))).default;
    case ICON_PROP_KEY.GlobalFilled:
      return (await __webpack_require__.e(/* import() */ 89388).then(__webpack_require__.bind(__webpack_require__, 689388))).default;
    case ICON_PROP_KEY.GoogleFilled:
      return (await __webpack_require__.e(/* import() */ 71778).then(__webpack_require__.bind(__webpack_require__, 371778))).default;
    case ICON_PROP_KEY.HighlightBackgroundFilled:
      return (await __webpack_require__.e(/* import() */ 71084).then(__webpack_require__.bind(__webpack_require__, 871084))).default;
    case ICON_PROP_KEY.HomepageFilled:
      return (await __webpack_require__.e(/* import() */ 91662).then(__webpack_require__.bind(__webpack_require__, 491662))).default;
    case ICON_PROP_KEY.ImageFilled:
      return (await __webpack_require__.e(/* import() */ 39973).then(__webpack_require__.bind(__webpack_require__, 739973))).default;
    case ICON_PROP_KEY.InforFilled:
      return (await __webpack_require__.e(/* import() */ 49459).then(__webpack_require__.bind(__webpack_require__, 649459))).default;
    case ICON_PROP_KEY.InstagramFilled:
      return (await __webpack_require__.e(/* import() */ 12456).then(__webpack_require__.bind(__webpack_require__, 812456))).default;
    case ICON_PROP_KEY.LayerFilled:
      return (await __webpack_require__.e(/* import() */ 484).then(__webpack_require__.bind(__webpack_require__, 500484))).default;
    case ICON_PROP_KEY.LeftAndRightSidebarDevFilled:
      return (await __webpack_require__.e(/* import() */ 86847).then(__webpack_require__.bind(__webpack_require__, 486847))).default;
    case ICON_PROP_KEY.LeftSidebarDevFilled:
      return (await __webpack_require__.e(/* import() */ 35926).then(__webpack_require__.bind(__webpack_require__, 335926))).default;
    case ICON_PROP_KEY.MoreProductFilled:
      return (await __webpack_require__.e(/* import() */ 16485).then(__webpack_require__.bind(__webpack_require__, 916485))).default;
    case ICON_PROP_KEY.NineFilled:
      return (await __webpack_require__.e(/* import() */ 75922).then(__webpack_require__.bind(__webpack_require__, 831041))).default;
    case ICON_PROP_KEY.NotificationFilled:
      return (await __webpack_require__.e(/* import() */ 45512).then(__webpack_require__.bind(__webpack_require__, 345512))).default;
    case ICON_PROP_KEY.NumberCounterFilled:
      return (await __webpack_require__.e(/* import() */ 49918).then(__webpack_require__.bind(__webpack_require__, 449918))).default;
    case ICON_PROP_KEY.OneFilled:
      return (await __webpack_require__.e(/* import() */ 22052).then(__webpack_require__.bind(__webpack_require__, 922052))).default;
    case ICON_PROP_KEY.OneColumnDevFilled:
      return (await __webpack_require__.e(/* import() */ 4698).then(__webpack_require__.bind(__webpack_require__, 4698))).default;
    case ICON_PROP_KEY.OptionsFilled:
      return (await __webpack_require__.e(/* import() */ 63613).then(__webpack_require__.bind(__webpack_require__, 863613))).default;
    case ICON_PROP_KEY.OrderFilled:
      return (await __webpack_require__.e(/* import() */ 97392).then(__webpack_require__.bind(__webpack_require__, 897392))).default;
    case ICON_PROP_KEY.PbCallFilled:
      return (await __webpack_require__.e(/* import() */ 89601).then(__webpack_require__.bind(__webpack_require__, 589601))).default;
    case ICON_PROP_KEY.PbInpageLinkFilled:
      return (await __webpack_require__.e(/* import() */ 96892).then(__webpack_require__.bind(__webpack_require__, 96892))).default;
    case ICON_PROP_KEY.PbMailFilled:
      return (await __webpack_require__.e(/* import() */ 53142).then(__webpack_require__.bind(__webpack_require__, 853142))).default;
    case ICON_PROP_KEY.PbNavigationCurvedFilled:
      return (await __webpack_require__.e(/* import() */ 85154).then(__webpack_require__.bind(__webpack_require__, 985154))).default;
    case ICON_PROP_KEY.PbNavigationRoundFilled:
      return (await __webpack_require__.e(/* import() */ 80802).then(__webpack_require__.bind(__webpack_require__, 680802))).default;
    case ICON_PROP_KEY.PbPaginationDotBigFilled:
      return (await __webpack_require__.e(/* import() */ 18103).then(__webpack_require__.bind(__webpack_require__, 818103))).default;
    case ICON_PROP_KEY.PbPaginationDotLineFilled:
      return (await __webpack_require__.e(/* import() */ 78050).then(__webpack_require__.bind(__webpack_require__, 978050))).default;
    case ICON_PROP_KEY.PbPaginationDotsFilled:
      return (await __webpack_require__.e(/* import() */ 91725).then(__webpack_require__.bind(__webpack_require__, 391725))).default;
    case ICON_PROP_KEY.PbPaginationLineFilled:
      return (await __webpack_require__.e(/* import() */ 26799).then(__webpack_require__.bind(__webpack_require__, 526799))).default;
    case ICON_PROP_KEY.PbSliderOneRowFilled:
      return (await __webpack_require__.e(/* import() */ 83036).then(__webpack_require__.bind(__webpack_require__, 583036))).default;
    case ICON_PROP_KEY.PbSliderThreeRowFilled:
      return (await __webpack_require__.e(/* import() */ 69268).then(__webpack_require__.bind(__webpack_require__, 469268))).default;
    case ICON_PROP_KEY.PbSliderTwoRowFilled:
      return (await __webpack_require__.e(/* import() */ 90565).then(__webpack_require__.bind(__webpack_require__, 490565))).default;
    case ICON_PROP_KEY.PhoneFilled:
      return (await __webpack_require__.e(/* import() */ 4384).then(__webpack_require__.bind(__webpack_require__, 804384))).default;
    case ICON_PROP_KEY.PlayBadgeFillFilled:
      return (await __webpack_require__.e(/* import() */ 65286).then(__webpack_require__.bind(__webpack_require__, 165286))).default;
    case ICON_PROP_KEY.PlayCircleFillFilled:
      return (await __webpack_require__.e(/* import() */ 5722).then(__webpack_require__.bind(__webpack_require__, 5722))).default;
    case ICON_PROP_KEY.PlayRoundedFillFilled:
      return (await __webpack_require__.e(/* import() */ 8167).then(__webpack_require__.bind(__webpack_require__, 208167))).default;
    case ICON_PROP_KEY.PlaySharpFillFilled:
      return (await __webpack_require__.e(/* import() */ 66395).then(__webpack_require__.bind(__webpack_require__, 566395))).default;
    case ICON_PROP_KEY.PlaySquareFillFilled:
      return (await __webpack_require__.e(/* import() */ 98146).then(__webpack_require__.bind(__webpack_require__, 398146))).default;
    case ICON_PROP_KEY.ProfileFilled:
      return (await __webpack_require__.e(/* import() */ 62472).then(__webpack_require__.bind(__webpack_require__, 962472))).default;
    case ICON_PROP_KEY.PromoFilled:
      return (await __webpack_require__.e(/* import() */ 18635).then(__webpack_require__.bind(__webpack_require__, 118635))).default;
    case ICON_PROP_KEY.RatingFilled:
      return (await __webpack_require__.e(/* import() */ 99302).then(__webpack_require__.bind(__webpack_require__, 899302))).default;
    case ICON_PROP_KEY.RightSidebarDevFilled:
      return (await __webpack_require__.e(/* import() */ 8380).then(__webpack_require__.bind(__webpack_require__, 708380))).default;
    case ICON_PROP_KEY.SaveFilled:
      return (await __webpack_require__.e(/* import() */ 58677).then(__webpack_require__.bind(__webpack_require__, 458677))).default;
    case ICON_PROP_KEY.SettingsFilled:
      return (await __webpack_require__.e(/* import() */ 65712).then(__webpack_require__.bind(__webpack_require__, 565712))).default;
    case ICON_PROP_KEY.SevenFilled:
      return (await __webpack_require__.e(/* import() */ 78159).then(__webpack_require__.bind(__webpack_require__, 678159))).default;
    case ICON_PROP_KEY.SixFilled:
      return (await __webpack_require__.e(/* import() */ 29079).then(__webpack_require__.bind(__webpack_require__, 929079))).default;
    case ICON_PROP_KEY.SixColumnDevFilled:
      return (await __webpack_require__.e(/* import() */ 3314).then(__webpack_require__.bind(__webpack_require__, 403314))).default;
    case ICON_PROP_KEY.SliderFilled:
      return (await __webpack_require__.e(/* import() */ 68217).then(__webpack_require__.bind(__webpack_require__, 268217))).default;
    case ICON_PROP_KEY.SuccessFilled:
      return (await __webpack_require__.e(/* import() */ 49777).then(__webpack_require__.bind(__webpack_require__, 549777))).default;
    case ICON_PROP_KEY.TenFilled:
      return (await __webpack_require__.e(/* import() */ 69080).then(__webpack_require__.bind(__webpack_require__, 869080))).default;
    case ICON_PROP_KEY.ThreeFilled:
      return (await __webpack_require__.e(/* import() */ 14196).then(__webpack_require__.bind(__webpack_require__, 214196))).default;
    case ICON_PROP_KEY.ThreeColumnsDevFilled:
      return (await __webpack_require__.e(/* import() */ 2591).then(__webpack_require__.bind(__webpack_require__, 302591))).default;
    case ICON_PROP_KEY.TickFilled:
      return (await __webpack_require__.e(/* import() */ 99707).then(__webpack_require__.bind(__webpack_require__, 699707))).default;
    case ICON_PROP_KEY.TiktokFilled:
      return (await __webpack_require__.e(/* import() */ 59528).then(__webpack_require__.bind(__webpack_require__, 159528))).default;
    case ICON_PROP_KEY.TwitterFilled:
      return (await __webpack_require__.e(/* import() */ 91041).then(__webpack_require__.bind(__webpack_require__, 391041))).default;
    case ICON_PROP_KEY.TwoFilled:
      return (await __webpack_require__.e(/* import() */ 92622).then(__webpack_require__.bind(__webpack_require__, 592622))).default;
    case ICON_PROP_KEY.TwoColumnsFilled:
      return (await __webpack_require__.e(/* import() */ 88909).then(__webpack_require__.bind(__webpack_require__, 488909))).default;
    case ICON_PROP_KEY.TwoColumnsDevFilled:
      return (await __webpack_require__.e(/* import() */ 89951).then(__webpack_require__.bind(__webpack_require__, 589951))).default;
    case ICON_PROP_KEY.TwoSmallColumnLeftDevFilled:
      return (await __webpack_require__.e(/* import() */ 96973).then(__webpack_require__.bind(__webpack_require__, 896973))).default;
    case ICON_PROP_KEY.TwoSmallColumnRightDevFilled:
      return (await __webpack_require__.e(/* import() */ 55147).then(__webpack_require__.bind(__webpack_require__, 155147))).default;
    case ICON_PROP_KEY.VerticalLineFilled:
      return (await __webpack_require__.e(/* import() */ 95106).then(__webpack_require__.bind(__webpack_require__, 795106))).default;
    case ICON_PROP_KEY.VoucherFilled:
      return (await __webpack_require__.e(/* import() */ 50882).then(__webpack_require__.bind(__webpack_require__, 350882))).default;
    case ICON_PROP_KEY.WarningFilled:
      return (await __webpack_require__.e(/* import() */ 72059).then(__webpack_require__.bind(__webpack_require__, 672059))).default;
    case ICON_PROP_KEY.YoutubeFilled:
      return (await __webpack_require__.e(/* import() */ 50013).then(__webpack_require__.bind(__webpack_require__, 150013))).default;
    case ICON_PROP_KEY.ZaloFilled:
      return (await __webpack_require__.e(/* import() */ 46647).then(__webpack_require__.bind(__webpack_require__, 146647))).default;
    case ICON_PROP_KEY.AcFlags:
      return (await __webpack_require__.e(/* import() */ 43119).then(__webpack_require__.bind(__webpack_require__, 843119))).default;
    case ICON_PROP_KEY.AdFlags:
      return (await __webpack_require__.e(/* import() */ 69930).then(__webpack_require__.bind(__webpack_require__, 669930))).default;
    case ICON_PROP_KEY.AeFlags:
      return (await __webpack_require__.e(/* import() */ 4892).then(__webpack_require__.bind(__webpack_require__, 404892))).default;
    case ICON_PROP_KEY.AfFlags:
      return (await __webpack_require__.e(/* import() */ 48574).then(__webpack_require__.bind(__webpack_require__, 948574))).default;
    case ICON_PROP_KEY.AgFlags:
      return (await __webpack_require__.e(/* import() */ 82136).then(__webpack_require__.bind(__webpack_require__, 182136))).default;
    case ICON_PROP_KEY.AiFlags:
      return (await __webpack_require__.e(/* import() */ 94950).then(__webpack_require__.bind(__webpack_require__, 429912))).default;
    case ICON_PROP_KEY.AlFlags:
      return (await __webpack_require__.e(/* import() */ 83594).then(__webpack_require__.bind(__webpack_require__, 983594))).default;
    case ICON_PROP_KEY.AmFlags:
      return (await __webpack_require__.e(/* import() */ 98).then(__webpack_require__.bind(__webpack_require__, 800098))).default;
    case ICON_PROP_KEY.AoFlags:
      return (await __webpack_require__.e(/* import() */ 54160).then(__webpack_require__.bind(__webpack_require__, 154160))).default;
    case ICON_PROP_KEY.AqFlags:
      return (await __webpack_require__.e(/* import() */ 83864).then(__webpack_require__.bind(__webpack_require__, 483864))).default;
    case ICON_PROP_KEY.ArFlags:
      return (await __webpack_require__.e(/* import() */ 19586).then(__webpack_require__.bind(__webpack_require__, 919586))).default;
    case ICON_PROP_KEY.AsFlags:
      return (await __webpack_require__.e(/* import() */ 67652).then(__webpack_require__.bind(__webpack_require__, 667652))).default;
    case ICON_PROP_KEY.AtFlags:
      return (await __webpack_require__.e(/* import() */ 38121).then(__webpack_require__.bind(__webpack_require__, 38121))).default;
    case ICON_PROP_KEY.AuFlags:
      return (await __webpack_require__.e(/* import() */ 68625).then(__webpack_require__.bind(__webpack_require__, 268625))).default;
    case ICON_PROP_KEY.AwFlags:
      return (await __webpack_require__.e(/* import() */ 88947).then(__webpack_require__.bind(__webpack_require__, 688947))).default;
    case ICON_PROP_KEY.AxFlags:
      return (await __webpack_require__.e(/* import() */ 89820).then(__webpack_require__.bind(__webpack_require__, 889820))).default;
    case ICON_PROP_KEY.AzFlags:
      return (await __webpack_require__.e(/* import() */ 8161).then(__webpack_require__.bind(__webpack_require__, 908161))).default;
    case ICON_PROP_KEY.BaFlags:
      return (await __webpack_require__.e(/* import() */ 56301).then(__webpack_require__.bind(__webpack_require__, 256301))).default;
    case ICON_PROP_KEY.BbFlags:
      return (await __webpack_require__.e(/* import() */ 7148).then(__webpack_require__.bind(__webpack_require__, 607148))).default;
    case ICON_PROP_KEY.BdFlags:
      return (await __webpack_require__.e(/* import() */ 52804).then(__webpack_require__.bind(__webpack_require__, 228583))).default;
    case ICON_PROP_KEY.BeFlags:
      return (await __webpack_require__.e(/* import() */ 1680).then(__webpack_require__.bind(__webpack_require__, 101680))).default;
    case ICON_PROP_KEY.BfFlags:
      return (await __webpack_require__.e(/* import() */ 25118).then(__webpack_require__.bind(__webpack_require__, 25118))).default;
    case ICON_PROP_KEY.BgFlags:
      return (await __webpack_require__.e(/* import() */ 61542).then(__webpack_require__.bind(__webpack_require__, 61542))).default;
    case ICON_PROP_KEY.BhFlags:
      return (await __webpack_require__.e(/* import() */ 58243).then(__webpack_require__.bind(__webpack_require__, 658243))).default;
    case ICON_PROP_KEY.BiFlags:
      return (await __webpack_require__.e(/* import() */ 39341).then(__webpack_require__.bind(__webpack_require__, 139341))).default;
    case ICON_PROP_KEY.BjFlags:
      return (await __webpack_require__.e(/* import() */ 845).then(__webpack_require__.bind(__webpack_require__, 400845))).default;
    case ICON_PROP_KEY.BlFlags:
      return (await __webpack_require__.e(/* import() */ 37493).then(__webpack_require__.bind(__webpack_require__, 837493))).default;
    case ICON_PROP_KEY.BmFlags:
      return (await __webpack_require__.e(/* import() */ 73519).then(__webpack_require__.bind(__webpack_require__, 773519))).default;
    case ICON_PROP_KEY.BnFlags:
      return (await __webpack_require__.e(/* import() */ 43602).then(__webpack_require__.bind(__webpack_require__, 143602))).default;
    case ICON_PROP_KEY.BoFlags:
      return (await __webpack_require__.e(/* import() */ 98190).then(__webpack_require__.bind(__webpack_require__, 198190))).default;
    case ICON_PROP_KEY.BqFlags:
      return (await __webpack_require__.e(/* import() */ 74954).then(__webpack_require__.bind(__webpack_require__, 974954))).default;
    case ICON_PROP_KEY.BrFlags:
      return (await __webpack_require__.e(/* import() */ 52757).then(__webpack_require__.bind(__webpack_require__, 452757))).default;
    case ICON_PROP_KEY.BsFlags:
      return (await __webpack_require__.e(/* import() */ 60214).then(__webpack_require__.bind(__webpack_require__, 260214))).default;
    case ICON_PROP_KEY.BtFlags:
      return (await __webpack_require__.e(/* import() */ 96994).then(__webpack_require__.bind(__webpack_require__, 596994))).default;
    case ICON_PROP_KEY.BvFlags:
      return (await __webpack_require__.e(/* import() */ 10413).then(__webpack_require__.bind(__webpack_require__, 510413))).default;
    case ICON_PROP_KEY.BwFlags:
      return (await __webpack_require__.e(/* import() */ 10869).then(__webpack_require__.bind(__webpack_require__, 410869))).default;
    case ICON_PROP_KEY.ByFlags:
      return (await __webpack_require__.e(/* import() */ 75391).then(__webpack_require__.bind(__webpack_require__, 875391))).default;
    case ICON_PROP_KEY.BzFlags:
      return (await __webpack_require__.e(/* import() */ 71615).then(__webpack_require__.bind(__webpack_require__, 171615))).default;
    case ICON_PROP_KEY.CaFlags:
      return (await __webpack_require__.e(/* import() */ 97568).then(__webpack_require__.bind(__webpack_require__, 897568))).default;
    case ICON_PROP_KEY.CcFlags:
      return (await __webpack_require__.e(/* import() */ 16970).then(__webpack_require__.bind(__webpack_require__, 516970))).default;
    case ICON_PROP_KEY.CdFlags:
      return (await __webpack_require__.e(/* import() */ 46564).then(__webpack_require__.bind(__webpack_require__, 246564))).default;
    case ICON_PROP_KEY.CfFlags:
      return (await __webpack_require__.e(/* import() */ 39955).then(__webpack_require__.bind(__webpack_require__, 939955))).default;
    case ICON_PROP_KEY.CgFlags:
      return (await __webpack_require__.e(/* import() */ 86564).then(__webpack_require__.bind(__webpack_require__, 786564))).default;
    case ICON_PROP_KEY.ChFlags:
      return (await __webpack_require__.e(/* import() */ 64029).then(__webpack_require__.bind(__webpack_require__, 464029))).default;
    case ICON_PROP_KEY.CiFlags:
      return (await __webpack_require__.e(/* import() */ 57360).then(__webpack_require__.bind(__webpack_require__, 876115))).default;
    case ICON_PROP_KEY.CkFlags:
      return (await __webpack_require__.e(/* import() */ 62285).then(__webpack_require__.bind(__webpack_require__, 962285))).default;
    case ICON_PROP_KEY.ClFlags:
      return (await __webpack_require__.e(/* import() */ 71512).then(__webpack_require__.bind(__webpack_require__, 71512))).default;
    case ICON_PROP_KEY.CmFlags:
      return (await __webpack_require__.e(/* import() */ 4109).then(__webpack_require__.bind(__webpack_require__, 304109))).default;
    case ICON_PROP_KEY.CnFlags:
      return (await __webpack_require__.e(/* import() */ 18768).then(__webpack_require__.bind(__webpack_require__, 318768))).default;
    case ICON_PROP_KEY.CoFlags:
      return (await __webpack_require__.e(/* import() */ 14212).then(__webpack_require__.bind(__webpack_require__, 814212))).default;
    case ICON_PROP_KEY.CrFlags:
      return (await __webpack_require__.e(/* import() */ 15495).then(__webpack_require__.bind(__webpack_require__, 415495))).default;
    case ICON_PROP_KEY.CuFlags:
      return (await __webpack_require__.e(/* import() */ 57020).then(__webpack_require__.bind(__webpack_require__, 457020))).default;
    case ICON_PROP_KEY.CvFlags:
      return (await __webpack_require__.e(/* import() */ 86632).then(__webpack_require__.bind(__webpack_require__, 586632))).default;
    case ICON_PROP_KEY.CwFlags:
      return (await __webpack_require__.e(/* import() */ 13493).then(__webpack_require__.bind(__webpack_require__, 313493))).default;
    case ICON_PROP_KEY.CxFlags:
      return (await __webpack_require__.e(/* import() */ 69882).then(__webpack_require__.bind(__webpack_require__, 969882))).default;
    case ICON_PROP_KEY.CyFlags:
      return (await __webpack_require__.e(/* import() */ 66333).then(__webpack_require__.bind(__webpack_require__, 66333))).default;
    case ICON_PROP_KEY.CzFlags:
      return (await __webpack_require__.e(/* import() */ 33823).then(__webpack_require__.bind(__webpack_require__, 233823))).default;
    case ICON_PROP_KEY.DeFlags:
      return (await __webpack_require__.e(/* import() */ 48).then(__webpack_require__.bind(__webpack_require__, 900048))).default;
    case ICON_PROP_KEY.DjFlags:
      return (await __webpack_require__.e(/* import() */ 29617).then(__webpack_require__.bind(__webpack_require__, 29617))).default;
    case ICON_PROP_KEY.DkFlags:
      return (await __webpack_require__.e(/* import() */ 58624).then(__webpack_require__.bind(__webpack_require__, 558624))).default;
    case ICON_PROP_KEY.DmFlags:
      return (await __webpack_require__.e(/* import() */ 72085).then(__webpack_require__.bind(__webpack_require__, 872085))).default;
    case ICON_PROP_KEY.DoFlags:
      return (await __webpack_require__.e(/* import() */ 75900).then(__webpack_require__.bind(__webpack_require__, 175900))).default;
    case ICON_PROP_KEY.DzFlags:
      return (await __webpack_require__.e(/* import() */ 31993).then(__webpack_require__.bind(__webpack_require__, 331993))).default;
    case ICON_PROP_KEY.EcFlags:
      return (await __webpack_require__.e(/* import() */ 47801).then(__webpack_require__.bind(__webpack_require__, 547801))).default;
    case ICON_PROP_KEY.EeFlags:
      return (await __webpack_require__.e(/* import() */ 10055).then(__webpack_require__.bind(__webpack_require__, 910055))).default;
    case ICON_PROP_KEY.EgFlags:
      return (await __webpack_require__.e(/* import() */ 41561).then(__webpack_require__.bind(__webpack_require__, 541561))).default;
    case ICON_PROP_KEY.EhFlags:
      return (await __webpack_require__.e(/* import() */ 67793).then(__webpack_require__.bind(__webpack_require__, 467793))).default;
    case ICON_PROP_KEY.ErFlags:
      return (await __webpack_require__.e(/* import() */ 87384).then(__webpack_require__.bind(__webpack_require__, 87384))).default;
    case ICON_PROP_KEY.EsFlags:
      return (await __webpack_require__.e(/* import() */ 2503).then(__webpack_require__.bind(__webpack_require__, 702503))).default;
    case ICON_PROP_KEY.EtFlags:
      return (await __webpack_require__.e(/* import() */ 33533).then(__webpack_require__.bind(__webpack_require__, 433533))).default;
    case ICON_PROP_KEY.EuFlags:
      return (await __webpack_require__.e(/* import() */ 58012).then(__webpack_require__.bind(__webpack_require__, 858012))).default;
    case ICON_PROP_KEY.FiFlags:
      return (await __webpack_require__.e(/* import() */ 57036).then(__webpack_require__.bind(__webpack_require__, 757036))).default;
    case ICON_PROP_KEY.FjFlags:
      return (await __webpack_require__.e(/* import() */ 94959).then(__webpack_require__.bind(__webpack_require__, 594959))).default;
    case ICON_PROP_KEY.FkFlags:
      return (await __webpack_require__.e(/* import() */ 38511).then(__webpack_require__.bind(__webpack_require__, 938511))).default;
    case ICON_PROP_KEY.FmFlags:
      return (await __webpack_require__.e(/* import() */ 67019).then(__webpack_require__.bind(__webpack_require__, 467019))).default;
    case ICON_PROP_KEY.FoFlags:
      return (await __webpack_require__.e(/* import() */ 91728).then(__webpack_require__.bind(__webpack_require__, 91728))).default;
    case ICON_PROP_KEY.FrFlags:
      return (await __webpack_require__.e(/* import() */ 52258).then(__webpack_require__.bind(__webpack_require__, 452258))).default;
    case ICON_PROP_KEY.GaFlags:
      return (await __webpack_require__.e(/* import() */ 49042).then(__webpack_require__.bind(__webpack_require__, 449042))).default;
    case ICON_PROP_KEY.GbFlags:
      return (await __webpack_require__.e(/* import() */ 15916).then(__webpack_require__.bind(__webpack_require__, 615916))).default;
    case ICON_PROP_KEY.GdFlags:
      return (await __webpack_require__.e(/* import() */ 36978).then(__webpack_require__.bind(__webpack_require__, 136978))).default;
    case ICON_PROP_KEY.GeAbFlags:
      return (await __webpack_require__.e(/* import() */ 89904).then(__webpack_require__.bind(__webpack_require__, 289904))).default;
    case ICON_PROP_KEY.GeOsFlags:
      return (await __webpack_require__.e(/* import() */ 62523).then(__webpack_require__.bind(__webpack_require__, 462523))).default;
    case ICON_PROP_KEY.GeFlags:
      return (await __webpack_require__.e(/* import() */ 53366).then(__webpack_require__.bind(__webpack_require__, 153366))).default;
    case ICON_PROP_KEY.GfFlags:
      return (await __webpack_require__.e(/* import() */ 68755).then(__webpack_require__.bind(__webpack_require__, 468755))).default;
    case ICON_PROP_KEY.GgFlags:
      return (await __webpack_require__.e(/* import() */ 4167).then(__webpack_require__.bind(__webpack_require__, 104167))).default;
    case ICON_PROP_KEY.GhFlags:
      return (await __webpack_require__.e(/* import() */ 98058).then(__webpack_require__.bind(__webpack_require__, 298058))).default;
    case ICON_PROP_KEY.GiFlags:
      return (await __webpack_require__.e(/* import() */ 29198).then(__webpack_require__.bind(__webpack_require__, 829198))).default;
    case ICON_PROP_KEY.GlFlags:
      return (await __webpack_require__.e(/* import() */ 43640).then(__webpack_require__.bind(__webpack_require__, 843640))).default;
    case ICON_PROP_KEY.GmFlags:
      return (await __webpack_require__.e(/* import() */ 77216).then(__webpack_require__.bind(__webpack_require__, 277216))).default;
    case ICON_PROP_KEY.GnFlags:
      return (await __webpack_require__.e(/* import() */ 18106).then(__webpack_require__.bind(__webpack_require__, 218106))).default;
    case ICON_PROP_KEY.GpFlags:
      return (await __webpack_require__.e(/* import() */ 17876).then(__webpack_require__.bind(__webpack_require__, 517876))).default;
    case ICON_PROP_KEY.GqFlags:
      return (await __webpack_require__.e(/* import() */ 65110).then(__webpack_require__.bind(__webpack_require__, 965110))).default;
    case ICON_PROP_KEY.GrFlags:
      return (await __webpack_require__.e(/* import() */ 16967).then(__webpack_require__.bind(__webpack_require__, 116967))).default;
    case ICON_PROP_KEY.GsFlags:
      return (await __webpack_require__.e(/* import() */ 40201).then(__webpack_require__.bind(__webpack_require__, 540201))).default;
    case ICON_PROP_KEY.GtFlags:
      return (await __webpack_require__.e(/* import() */ 62842).then(__webpack_require__.bind(__webpack_require__, 662842))).default;
    case ICON_PROP_KEY.GuFlags:
      return (await __webpack_require__.e(/* import() */ 6840).then(__webpack_require__.bind(__webpack_require__, 306840))).default;
    case ICON_PROP_KEY.GwFlags:
      return (await __webpack_require__.e(/* import() */ 33043).then(__webpack_require__.bind(__webpack_require__, 933043))).default;
    case ICON_PROP_KEY.GyFlags:
      return (await __webpack_require__.e(/* import() */ 79978).then(__webpack_require__.bind(__webpack_require__, 879978))).default;
    case ICON_PROP_KEY.HkFlags:
      return (await __webpack_require__.e(/* import() */ 7805).then(__webpack_require__.bind(__webpack_require__, 607805))).default;
    case ICON_PROP_KEY.HmFlags:
      return (await __webpack_require__.e(/* import() */ 53270).then(__webpack_require__.bind(__webpack_require__, 753270))).default;
    case ICON_PROP_KEY.HnFlags:
      return (await __webpack_require__.e(/* import() */ 56777).then(__webpack_require__.bind(__webpack_require__, 856777))).default;
    case ICON_PROP_KEY.HrFlags:
      return (await __webpack_require__.e(/* import() */ 49591).then(__webpack_require__.bind(__webpack_require__, 49591))).default;
    case ICON_PROP_KEY.HtFlags:
      return (await __webpack_require__.e(/* import() */ 87166).then(__webpack_require__.bind(__webpack_require__, 287166))).default;
    case ICON_PROP_KEY.HuFlags:
      return (await __webpack_require__.e(/* import() */ 46786).then(__webpack_require__.bind(__webpack_require__, 646786))).default;
    case ICON_PROP_KEY.IcFlags:
      return (await __webpack_require__.e(/* import() */ 48511).then(__webpack_require__.bind(__webpack_require__, 148511))).default;
    case ICON_PROP_KEY.IdFlags:
      return (await __webpack_require__.e(/* import() */ 4214).then(__webpack_require__.bind(__webpack_require__, 604214))).default;
    case ICON_PROP_KEY.IeFlags:
      return (await __webpack_require__.e(/* import() */ 31837).then(__webpack_require__.bind(__webpack_require__, 731837))).default;
    case ICON_PROP_KEY.IlFlags:
      return (await __webpack_require__.e(/* import() */ 33169).then(__webpack_require__.bind(__webpack_require__, 733169))).default;
    case ICON_PROP_KEY.ImFlags:
      return (await __webpack_require__.e(/* import() */ 4955).then(__webpack_require__.bind(__webpack_require__, 404955))).default;
    case ICON_PROP_KEY.InFlags:
      return (await __webpack_require__.e(/* import() */ 16920).then(__webpack_require__.bind(__webpack_require__, 516920))).default;
    case ICON_PROP_KEY.IoFlags:
      return (await __webpack_require__.e(/* import() */ 76562).then(__webpack_require__.bind(__webpack_require__, 676562))).default;
    case ICON_PROP_KEY.IqFlags:
      return (await __webpack_require__.e(/* import() */ 55497).then(__webpack_require__.bind(__webpack_require__, 455497))).default;
    case ICON_PROP_KEY.IrFlags:
      return (await __webpack_require__.e(/* import() */ 62928).then(__webpack_require__.bind(__webpack_require__, 362928))).default;
    case ICON_PROP_KEY.IsFlags:
      return (await __webpack_require__.e(/* import() */ 16177).then(__webpack_require__.bind(__webpack_require__, 16177))).default;
    case ICON_PROP_KEY.ItFlags:
      return (await __webpack_require__.e(/* import() */ 54413).then(__webpack_require__.bind(__webpack_require__, 154413))).default;
    case ICON_PROP_KEY.JeFlags:
      return (await __webpack_require__.e(/* import() */ 92936).then(__webpack_require__.bind(__webpack_require__, 892936))).default;
    case ICON_PROP_KEY.JmFlags:
      return (await __webpack_require__.e(/* import() */ 7219).then(__webpack_require__.bind(__webpack_require__, 707219))).default;
    case ICON_PROP_KEY.JoFlags:
      return (await __webpack_require__.e(/* import() */ 39091).then(__webpack_require__.bind(__webpack_require__, 339091))).default;
    case ICON_PROP_KEY.JpFlags:
      return (await __webpack_require__.e(/* import() */ 16626).then(__webpack_require__.bind(__webpack_require__, 216626))).default;
    case ICON_PROP_KEY.KeFlags:
      return (await __webpack_require__.e(/* import() */ 66693).then(__webpack_require__.bind(__webpack_require__, 766693))).default;
    case ICON_PROP_KEY.KgFlags:
      return (await __webpack_require__.e(/* import() */ 19457).then(__webpack_require__.bind(__webpack_require__, 319457))).default;
    case ICON_PROP_KEY.KhFlags:
      return (await __webpack_require__.e(/* import() */ 16897).then(__webpack_require__.bind(__webpack_require__, 16897))).default;
    case ICON_PROP_KEY.KiFlags:
      return (await __webpack_require__.e(/* import() */ 96071).then(__webpack_require__.bind(__webpack_require__, 796071))).default;
    case ICON_PROP_KEY.KmFlags:
      return (await __webpack_require__.e(/* import() */ 23139).then(__webpack_require__.bind(__webpack_require__, 123139))).default;
    case ICON_PROP_KEY.KnFlags:
      return (await __webpack_require__.e(/* import() */ 60573).then(__webpack_require__.bind(__webpack_require__, 360573))).default;
    case ICON_PROP_KEY.KpFlags:
      return (await __webpack_require__.e(/* import() */ 57832).then(__webpack_require__.bind(__webpack_require__, 957832))).default;
    case ICON_PROP_KEY.KrFlags:
      return (await __webpack_require__.e(/* import() */ 37456).then(__webpack_require__.bind(__webpack_require__, 637456))).default;
    case ICON_PROP_KEY.KwFlags:
      return (await __webpack_require__.e(/* import() */ 62971).then(__webpack_require__.bind(__webpack_require__, 662971))).default;
    case ICON_PROP_KEY.KyFlags:
      return (await __webpack_require__.e(/* import() */ 43250).then(__webpack_require__.bind(__webpack_require__, 643250))).default;
    case ICON_PROP_KEY.KzFlags:
      return (await __webpack_require__.e(/* import() */ 1670).then(__webpack_require__.bind(__webpack_require__, 901670))).default;
    case ICON_PROP_KEY.LaFlags:
      return (await __webpack_require__.e(/* import() */ 53785).then(__webpack_require__.bind(__webpack_require__, 53785))).default;
    case ICON_PROP_KEY.LbFlags:
      return (await __webpack_require__.e(/* import() */ 94919).then(__webpack_require__.bind(__webpack_require__, 794919))).default;
    case ICON_PROP_KEY.LcFlags:
      return (await __webpack_require__.e(/* import() */ 97688).then(__webpack_require__.bind(__webpack_require__, 97688))).default;
    case ICON_PROP_KEY.LiFlags:
      return (await __webpack_require__.e(/* import() */ 78994).then(__webpack_require__.bind(__webpack_require__, 578994))).default;
    case ICON_PROP_KEY.LkFlags:
      return (await __webpack_require__.e(/* import() */ 17151).then(__webpack_require__.bind(__webpack_require__, 717151))).default;
    case ICON_PROP_KEY.LrFlags:
      return (await __webpack_require__.e(/* import() */ 27633).then(__webpack_require__.bind(__webpack_require__, 27633))).default;
    case ICON_PROP_KEY.LsFlags:
      return (await __webpack_require__.e(/* import() */ 48973).then(__webpack_require__.bind(__webpack_require__, 148973))).default;
    case ICON_PROP_KEY.LtFlags:
      return (await __webpack_require__.e(/* import() */ 65934).then(__webpack_require__.bind(__webpack_require__, 865934))).default;
    case ICON_PROP_KEY.LuFlags:
      return (await __webpack_require__.e(/* import() */ 16260).then(__webpack_require__.bind(__webpack_require__, 916260))).default;
    case ICON_PROP_KEY.LvFlags:
      return (await __webpack_require__.e(/* import() */ 1844).then(__webpack_require__.bind(__webpack_require__, 101844))).default;
    case ICON_PROP_KEY.LyFlags:
      return (await __webpack_require__.e(/* import() */ 99856).then(__webpack_require__.bind(__webpack_require__, 899856))).default;
    case ICON_PROP_KEY.MaFlags:
      return (await __webpack_require__.e(/* import() */ 77219).then(__webpack_require__.bind(__webpack_require__, 677219))).default;
    case ICON_PROP_KEY.McFlags:
      return (await __webpack_require__.e(/* import() */ 46000).then(__webpack_require__.bind(__webpack_require__, 346000))).default;
    case ICON_PROP_KEY.MdFlags:
      return (await __webpack_require__.e(/* import() */ 31208).then(__webpack_require__.bind(__webpack_require__, 331208))).default;
    case ICON_PROP_KEY.MeFlags:
      return (await __webpack_require__.e(/* import() */ 47282).then(__webpack_require__.bind(__webpack_require__, 47282))).default;
    case ICON_PROP_KEY.MfFlags:
      return (await __webpack_require__.e(/* import() */ 48115).then(__webpack_require__.bind(__webpack_require__, 48115))).default;
    case ICON_PROP_KEY.MgFlags:
      return (await __webpack_require__.e(/* import() */ 22904).then(__webpack_require__.bind(__webpack_require__, 622904))).default;
    case ICON_PROP_KEY.MhFlags:
      return (await __webpack_require__.e(/* import() */ 96211).then(__webpack_require__.bind(__webpack_require__, 296211))).default;
    case ICON_PROP_KEY.MkFlags:
      return (await __webpack_require__.e(/* import() */ 54456).then(__webpack_require__.bind(__webpack_require__, 354456))).default;
    case ICON_PROP_KEY.MlFlags:
      return (await __webpack_require__.e(/* import() */ 28597).then(__webpack_require__.bind(__webpack_require__, 728597))).default;
    case ICON_PROP_KEY.MmFlags:
      return (await __webpack_require__.e(/* import() */ 91975).then(__webpack_require__.bind(__webpack_require__, 491975))).default;
    case ICON_PROP_KEY.MnFlags:
      return (await __webpack_require__.e(/* import() */ 77067).then(__webpack_require__.bind(__webpack_require__, 177067))).default;
    case ICON_PROP_KEY.MoFlags:
      return (await __webpack_require__.e(/* import() */ 40333).then(__webpack_require__.bind(__webpack_require__, 140333))).default;
    case ICON_PROP_KEY.MpFlags:
      return (await __webpack_require__.e(/* import() */ 22307).then(__webpack_require__.bind(__webpack_require__, 822307))).default;
    case ICON_PROP_KEY.MqFlags:
      return (await __webpack_require__.e(/* import() */ 53724).then(__webpack_require__.bind(__webpack_require__, 353724))).default;
    case ICON_PROP_KEY.MrFlags:
      return (await __webpack_require__.e(/* import() */ 96440).then(__webpack_require__.bind(__webpack_require__, 896440))).default;
    case ICON_PROP_KEY.MsFlags:
      return (await __webpack_require__.e(/* import() */ 5876).then(__webpack_require__.bind(__webpack_require__, 805876))).default;
    case ICON_PROP_KEY.MtFlags:
      return (await __webpack_require__.e(/* import() */ 97861).then(__webpack_require__.bind(__webpack_require__, 697861))).default;
    case ICON_PROP_KEY.MuFlags:
      return (await __webpack_require__.e(/* import() */ 88094).then(__webpack_require__.bind(__webpack_require__, 314196))).default;
    case ICON_PROP_KEY.MvFlags:
      return (await __webpack_require__.e(/* import() */ 20790).then(__webpack_require__.bind(__webpack_require__, 20790))).default;
    case ICON_PROP_KEY.MwFlags:
      return (await __webpack_require__.e(/* import() */ 80850).then(__webpack_require__.bind(__webpack_require__, 780850))).default;
    case ICON_PROP_KEY.MxFlags:
      return (await __webpack_require__.e(/* import() */ 55893).then(__webpack_require__.bind(__webpack_require__, 355893))).default;
    case ICON_PROP_KEY.MyFlags:
      return (await __webpack_require__.e(/* import() */ 90986).then(__webpack_require__.bind(__webpack_require__, 190986))).default;
    case ICON_PROP_KEY.MzFlags:
      return (await __webpack_require__.e(/* import() */ 55152).then(__webpack_require__.bind(__webpack_require__, 55152))).default;
    case ICON_PROP_KEY.NaFlags:
      return (await __webpack_require__.e(/* import() */ 45047).then(__webpack_require__.bind(__webpack_require__, 145047))).default;
    case ICON_PROP_KEY.NcFlags:
      return (await __webpack_require__.e(/* import() */ 8611).then(__webpack_require__.bind(__webpack_require__, 308611))).default;
    case ICON_PROP_KEY.NeFlags:
      return (await __webpack_require__.e(/* import() */ 41185).then(__webpack_require__.bind(__webpack_require__, 941185))).default;
    case ICON_PROP_KEY.NfFlags:
      return (await __webpack_require__.e(/* import() */ 40401).then(__webpack_require__.bind(__webpack_require__, 40401))).default;
    case ICON_PROP_KEY.NgFlags:
      return (await __webpack_require__.e(/* import() */ 42640).then(__webpack_require__.bind(__webpack_require__, 742640))).default;
    case ICON_PROP_KEY.NiFlags:
      return (await __webpack_require__.e(/* import() */ 7093).then(__webpack_require__.bind(__webpack_require__, 607093))).default;
    case ICON_PROP_KEY.NlFlags:
      return (await __webpack_require__.e(/* import() */ 39514).then(__webpack_require__.bind(__webpack_require__, 539514))).default;
    case ICON_PROP_KEY.NoFlags:
      return (await __webpack_require__.e(/* import() */ 12287).then(__webpack_require__.bind(__webpack_require__, 612287))).default;
    case ICON_PROP_KEY.NpFlags:
      return (await __webpack_require__.e(/* import() */ 57709).then(__webpack_require__.bind(__webpack_require__, 757709))).default;
    case ICON_PROP_KEY.NrFlags:
      return (await __webpack_require__.e(/* import() */ 36421).then(__webpack_require__.bind(__webpack_require__, 336421))).default;
    case ICON_PROP_KEY.NuFlags:
      return (await __webpack_require__.e(/* import() */ 83339).then(__webpack_require__.bind(__webpack_require__, 483339))).default;
    case ICON_PROP_KEY.NzFlags:
      return (await __webpack_require__.e(/* import() */ 71432).then(__webpack_require__.bind(__webpack_require__, 71432))).default;
    case ICON_PROP_KEY.OmFlags:
      return (await __webpack_require__.e(/* import() */ 22941).then(__webpack_require__.bind(__webpack_require__, 222941))).default;
    case ICON_PROP_KEY.PaFlags:
      return (await __webpack_require__.e(/* import() */ 14539).then(__webpack_require__.bind(__webpack_require__, 614539))).default;
    case ICON_PROP_KEY.PeFlags:
      return (await __webpack_require__.e(/* import() */ 36283).then(__webpack_require__.bind(__webpack_require__, 936283))).default;
    case ICON_PROP_KEY.PfFlags:
      return (await __webpack_require__.e(/* import() */ 57606).then(__webpack_require__.bind(__webpack_require__, 257606))).default;
    case ICON_PROP_KEY.PgFlags:
      return (await __webpack_require__.e(/* import() */ 1509).then(__webpack_require__.bind(__webpack_require__, 201509))).default;
    case ICON_PROP_KEY.PhFlags:
      return (await __webpack_require__.e(/* import() */ 22700).then(__webpack_require__.bind(__webpack_require__, 322700))).default;
    case ICON_PROP_KEY.PkFlags:
      return (await __webpack_require__.e(/* import() */ 14978).then(__webpack_require__.bind(__webpack_require__, 214978))).default;
    case ICON_PROP_KEY.PlFlags:
      return (await __webpack_require__.e(/* import() */ 5234).then(__webpack_require__.bind(__webpack_require__, 5234))).default;
    case ICON_PROP_KEY.PmFlags:
      return (await __webpack_require__.e(/* import() */ 37860).then(__webpack_require__.bind(__webpack_require__, 137860))).default;
    case ICON_PROP_KEY.PnFlags:
      return (await __webpack_require__.e(/* import() */ 66139).then(__webpack_require__.bind(__webpack_require__, 666139))).default;
    case ICON_PROP_KEY.PrFlags:
      return (await __webpack_require__.e(/* import() */ 98825).then(__webpack_require__.bind(__webpack_require__, 98825))).default;
    case ICON_PROP_KEY.PsFlags:
      return (await __webpack_require__.e(/* import() */ 96537).then(__webpack_require__.bind(__webpack_require__, 296537))).default;
    case ICON_PROP_KEY.PtFlags:
      return (await __webpack_require__.e(/* import() */ 22772).then(__webpack_require__.bind(__webpack_require__, 922772))).default;
    case ICON_PROP_KEY.PwFlags:
      return (await __webpack_require__.e(/* import() */ 32770).then(__webpack_require__.bind(__webpack_require__, 232770))).default;
    case ICON_PROP_KEY.PyFlags:
      return (await __webpack_require__.e(/* import() */ 94440).then(__webpack_require__.bind(__webpack_require__, 394440))).default;
    case ICON_PROP_KEY.QaFlags:
      return (await __webpack_require__.e(/* import() */ 92618).then(__webpack_require__.bind(__webpack_require__, 392618))).default;
    case ICON_PROP_KEY.ReFlags:
      return (await __webpack_require__.e(/* import() */ 50279).then(__webpack_require__.bind(__webpack_require__, 250279))).default;
    case ICON_PROP_KEY.RoFlags:
      return (await __webpack_require__.e(/* import() */ 56652).then(__webpack_require__.bind(__webpack_require__, 156652))).default;
    case ICON_PROP_KEY.RsFlags:
      return (await __webpack_require__.e(/* import() */ 63278).then(__webpack_require__.bind(__webpack_require__, 363278))).default;
    case ICON_PROP_KEY.RuFlags:
      return (await __webpack_require__.e(/* import() */ 33452).then(__webpack_require__.bind(__webpack_require__, 533452))).default;
    case ICON_PROP_KEY.RwFlags:
      return (await __webpack_require__.e(/* import() */ 79473).then(__webpack_require__.bind(__webpack_require__, 479473))).default;
    case ICON_PROP_KEY.SaFlags:
      return (await __webpack_require__.e(/* import() */ 31487).then(__webpack_require__.bind(__webpack_require__, 631487))).default;
    case ICON_PROP_KEY.SbFlags:
      return (await __webpack_require__.e(/* import() */ 75400).then(__webpack_require__.bind(__webpack_require__, 675400))).default;
    case ICON_PROP_KEY.ScFlags:
      return (await __webpack_require__.e(/* import() */ 15223).then(__webpack_require__.bind(__webpack_require__, 315223))).default;
    case ICON_PROP_KEY.SdFlags:
      return (await __webpack_require__.e(/* import() */ 861).then(__webpack_require__.bind(__webpack_require__, 100861))).default;
    case ICON_PROP_KEY.SeFlags:
      return (await __webpack_require__.e(/* import() */ 36831).then(__webpack_require__.bind(__webpack_require__, 236831))).default;
    case ICON_PROP_KEY.SgFlags:
      return (await __webpack_require__.e(/* import() */ 91721).then(__webpack_require__.bind(__webpack_require__, 491721))).default;
    case ICON_PROP_KEY.ShFlags:
      return (await __webpack_require__.e(/* import() */ 52196).then(__webpack_require__.bind(__webpack_require__, 52196))).default;
    case ICON_PROP_KEY.SiFlags:
      return (await __webpack_require__.e(/* import() */ 31348).then(__webpack_require__.bind(__webpack_require__, 631348))).default;
    case ICON_PROP_KEY.SjFlags:
      return (await __webpack_require__.e(/* import() */ 65942).then(__webpack_require__.bind(__webpack_require__, 465942))).default;
    case ICON_PROP_KEY.SkFlags:
      return (await __webpack_require__.e(/* import() */ 80366).then(__webpack_require__.bind(__webpack_require__, 880366))).default;
    case ICON_PROP_KEY.SlFlags:
      return (await __webpack_require__.e(/* import() */ 42441).then(__webpack_require__.bind(__webpack_require__, 442441))).default;
    case ICON_PROP_KEY.SmFlags:
      return (await __webpack_require__.e(/* import() */ 62769).then(__webpack_require__.bind(__webpack_require__, 462769))).default;
    case ICON_PROP_KEY.SnFlags:
      return (await __webpack_require__.e(/* import() */ 81239).then(__webpack_require__.bind(__webpack_require__, 181239))).default;
    case ICON_PROP_KEY.SoFlags:
      return (await __webpack_require__.e(/* import() */ 94318).then(__webpack_require__.bind(__webpack_require__, 794318))).default;
    case ICON_PROP_KEY.SrFlags:
      return (await __webpack_require__.e(/* import() */ 36961).then(__webpack_require__.bind(__webpack_require__, 936961))).default;
    case ICON_PROP_KEY.SsFlags:
      return (await __webpack_require__.e(/* import() */ 33962).then(__webpack_require__.bind(__webpack_require__, 133962))).default;
    case ICON_PROP_KEY.StFlags:
      return (await __webpack_require__.e(/* import() */ 34928).then(__webpack_require__.bind(__webpack_require__, 34928))).default;
    case ICON_PROP_KEY.SvFlags:
      return (await __webpack_require__.e(/* import() */ 54622).then(__webpack_require__.bind(__webpack_require__, 854622))).default;
    case ICON_PROP_KEY.SxFlags:
      return (await __webpack_require__.e(/* import() */ 55594).then(__webpack_require__.bind(__webpack_require__, 155594))).default;
    case ICON_PROP_KEY.SyFlags:
      return (await __webpack_require__.e(/* import() */ 12611).then(__webpack_require__.bind(__webpack_require__, 812611))).default;
    case ICON_PROP_KEY.SzFlags:
      return (await __webpack_require__.e(/* import() */ 49744).then(__webpack_require__.bind(__webpack_require__, 249744))).default;
    case ICON_PROP_KEY.TaFlags:
      return (await __webpack_require__.e(/* import() */ 72062).then(__webpack_require__.bind(__webpack_require__, 272062))).default;
    case ICON_PROP_KEY.TcFlags:
      return (await __webpack_require__.e(/* import() */ 51754).then(__webpack_require__.bind(__webpack_require__, 851754))).default;
    case ICON_PROP_KEY.TdFlags:
      return (await __webpack_require__.e(/* import() */ 44010).then(__webpack_require__.bind(__webpack_require__, 944010))).default;
    case ICON_PROP_KEY.TfFlags:
      return (await __webpack_require__.e(/* import() */ 54114).then(__webpack_require__.bind(__webpack_require__, 454114))).default;
    case ICON_PROP_KEY.TgFlags:
      return (await __webpack_require__.e(/* import() */ 78564).then(__webpack_require__.bind(__webpack_require__, 178564))).default;
    case ICON_PROP_KEY.ThFlags:
      return (await __webpack_require__.e(/* import() */ 79938).then(__webpack_require__.bind(__webpack_require__, 279938))).default;
    case ICON_PROP_KEY.TjFlags:
      return (await __webpack_require__.e(/* import() */ 72577).then(__webpack_require__.bind(__webpack_require__, 472577))).default;
    case ICON_PROP_KEY.TkFlags:
      return (await __webpack_require__.e(/* import() */ 85865).then(__webpack_require__.bind(__webpack_require__, 985865))).default;
    case ICON_PROP_KEY.TlFlags:
      return (await __webpack_require__.e(/* import() */ 46873).then(__webpack_require__.bind(__webpack_require__, 646873))).default;
    case ICON_PROP_KEY.TmFlags:
      return (await __webpack_require__.e(/* import() */ 6198).then(__webpack_require__.bind(__webpack_require__, 606198))).default;
    case ICON_PROP_KEY.TnFlags:
      return (await __webpack_require__.e(/* import() */ 58983).then(__webpack_require__.bind(__webpack_require__, 158983))).default;
    case ICON_PROP_KEY.ToFlags:
      return (await __webpack_require__.e(/* import() */ 39970).then(__webpack_require__.bind(__webpack_require__, 239970))).default;
    case ICON_PROP_KEY.TrFlags:
      return (await __webpack_require__.e(/* import() */ 64940).then(__webpack_require__.bind(__webpack_require__, 264940))).default;
    case ICON_PROP_KEY.TtFlags:
      return (await __webpack_require__.e(/* import() */ 16736).then(__webpack_require__.bind(__webpack_require__, 616736))).default;
    case ICON_PROP_KEY.TvFlags:
      return (await __webpack_require__.e(/* import() */ 61721).then(__webpack_require__.bind(__webpack_require__, 561721))).default;
    case ICON_PROP_KEY.TwFlags:
      return (await __webpack_require__.e(/* import() */ 28182).then(__webpack_require__.bind(__webpack_require__, 28182))).default;
    case ICON_PROP_KEY.TzFlags:
      return (await __webpack_require__.e(/* import() */ 5778).then(__webpack_require__.bind(__webpack_require__, 105778))).default;
    case ICON_PROP_KEY.UaFlags:
      return (await __webpack_require__.e(/* import() */ 15616).then(__webpack_require__.bind(__webpack_require__, 415616))).default;
    case ICON_PROP_KEY.UgFlags:
      return (await __webpack_require__.e(/* import() */ 91995).then(__webpack_require__.bind(__webpack_require__, 691995))).default;
    case ICON_PROP_KEY.UmFlags:
      return (await __webpack_require__.e(/* import() */ 61735).then(__webpack_require__.bind(__webpack_require__, 561735))).default;
    case ICON_PROP_KEY.UsFlags:
      return (await __webpack_require__.e(/* import() */ 54588).then(__webpack_require__.bind(__webpack_require__, 654588))).default;
    case ICON_PROP_KEY.UyFlags:
      return (await __webpack_require__.e(/* import() */ 26610).then(__webpack_require__.bind(__webpack_require__, 526610))).default;
    case ICON_PROP_KEY.UzFlags:
      return (await __webpack_require__.e(/* import() */ 24192).then(__webpack_require__.bind(__webpack_require__, 824192))).default;
    case ICON_PROP_KEY.VaFlags:
      return (await __webpack_require__.e(/* import() */ 30488).then(__webpack_require__.bind(__webpack_require__, 130488))).default;
    case ICON_PROP_KEY.VcFlags:
      return (await __webpack_require__.e(/* import() */ 37088).then(__webpack_require__.bind(__webpack_require__, 637088))).default;
    case ICON_PROP_KEY.VeFlags:
      return (await __webpack_require__.e(/* import() */ 63590).then(__webpack_require__.bind(__webpack_require__, 163590))).default;
    case ICON_PROP_KEY.VgFlags:
      return (await __webpack_require__.e(/* import() */ 54828).then(__webpack_require__.bind(__webpack_require__, 254828))).default;
    case ICON_PROP_KEY.ViFlags:
      return (await __webpack_require__.e(/* import() */ 92363).then(__webpack_require__.bind(__webpack_require__, 792363))).default;
    case ICON_PROP_KEY.VnFlags:
      return (await __webpack_require__.e(/* import() */ 4113).then(__webpack_require__.bind(__webpack_require__, 304113))).default;
    case ICON_PROP_KEY.VuFlags:
      return (await __webpack_require__.e(/* import() */ 26089).then(__webpack_require__.bind(__webpack_require__, 826089))).default;
    case ICON_PROP_KEY.WfFlags:
      return (await __webpack_require__.e(/* import() */ 16898).then(__webpack_require__.bind(__webpack_require__, 716898))).default;
    case ICON_PROP_KEY.WsFlags:
      return (await __webpack_require__.e(/* import() */ 30502).then(__webpack_require__.bind(__webpack_require__, 130502))).default;
    case ICON_PROP_KEY.XkFlags:
      return (await __webpack_require__.e(/* import() */ 99007).then(__webpack_require__.bind(__webpack_require__, 599007))).default;
    case ICON_PROP_KEY.YeFlags:
      return (await __webpack_require__.e(/* import() */ 33574).then(__webpack_require__.bind(__webpack_require__, 133574))).default;
    case ICON_PROP_KEY.YtFlags:
      return (await __webpack_require__.e(/* import() */ 64915).then(__webpack_require__.bind(__webpack_require__, 764915))).default;
    case ICON_PROP_KEY.ZaFlags:
      return (await __webpack_require__.e(/* import() */ 73470).then(__webpack_require__.bind(__webpack_require__, 673470))).default;
    case ICON_PROP_KEY.ZmFlags:
      return (await __webpack_require__.e(/* import() */ 2846).then(__webpack_require__.bind(__webpack_require__, 502846))).default;
    case ICON_PROP_KEY.ZwFlags:
      return (await __webpack_require__.e(/* import() */ 50740).then(__webpack_require__.bind(__webpack_require__, 250740))).default;
    case ICON_PROP_KEY.AddAlternativeOutlined:
      return (await __webpack_require__.e(/* import() */ 30352).then(__webpack_require__.bind(__webpack_require__, 130352))).default;
    case ICON_PROP_KEY.ClockAlternativeOutlined:
      return (await __webpack_require__.e(/* import() */ 37318).then(__webpack_require__.bind(__webpack_require__, 437318))).default;
    case ICON_PROP_KEY.DirectionAlternativeOutlined:
      return (await __webpack_require__.e(/* import() */ 40994).then(__webpack_require__.bind(__webpack_require__, 140994))).default;
    case ICON_PROP_KEY.FavouriteAlternativeOutlined:
      return (await __webpack_require__.e(/* import() */ 21553).then(__webpack_require__.bind(__webpack_require__, 321553))).default;
    case ICON_PROP_KEY.FormScaleAlternativeOutlined:
      return (await __webpack_require__.e(/* import() */ 82640).then(__webpack_require__.bind(__webpack_require__, 382640))).default;
    case ICON_PROP_KEY.HomepageAlternativeOutlined:
      return (await __webpack_require__.e(/* import() */ 45500).then(__webpack_require__.bind(__webpack_require__, 745500))).default;
    case ICON_PROP_KEY.LaptopAlternativeOutlined:
      return (await __webpack_require__.e(/* import() */ 83668).then(__webpack_require__.bind(__webpack_require__, 383668))).default;
    case ICON_PROP_KEY.MarkAsReadAlternativeOutlined:
      return (await __webpack_require__.e(/* import() */ 93582).then(__webpack_require__.bind(__webpack_require__, 993582))).default;
    case ICON_PROP_KEY.RatingAlternativeOutlined:
      return (await __webpack_require__.e(/* import() */ 52798).then(__webpack_require__.bind(__webpack_require__, 452798))).default;
    case ICON_PROP_KEY.SettingAlternativeOutlined:
      return (await __webpack_require__.e(/* import() */ 50621).then(__webpack_require__.bind(__webpack_require__, 650621))).default;
    case ICON_PROP_KEY.SuccessAlternativeOutlined:
      return (await __webpack_require__.e(/* import() */ 95795).then(__webpack_require__.bind(__webpack_require__, 595795))).default;
    case ICON_PROP_KEY.AccordionOutlined:
      return (await __webpack_require__.e(/* import() */ 36878).then(__webpack_require__.bind(__webpack_require__, 836878))).default;
    case ICON_PROP_KEY.AccountOutlined:
      return (await __webpack_require__.e(/* import() */ 51090).then(__webpack_require__.bind(__webpack_require__, 951090))).default;
    case ICON_PROP_KEY.AddItemOutlined:
      return (await __webpack_require__.e(/* import() */ 69522).then(__webpack_require__.bind(__webpack_require__, 569522))).default;
    case ICON_PROP_KEY.AddOutlined:
      return (await __webpack_require__.e(/* import() */ 67191).then(__webpack_require__.bind(__webpack_require__, 467191))).default;
    case ICON_PROP_KEY.AdvisoryOutlined:
      return (await __webpack_require__.e(/* import() */ 77525).then(__webpack_require__.bind(__webpack_require__, 577525))).default;
    case ICON_PROP_KEY.AlignCenterOutlined:
      return (await __webpack_require__.e(/* import() */ 96189).then(__webpack_require__.bind(__webpack_require__, 96189))).default;
    case ICON_PROP_KEY.AlignJustifyOutlined:
      return (await __webpack_require__.e(/* import() */ 13849).then(__webpack_require__.bind(__webpack_require__, 413849))).default;
    case ICON_PROP_KEY.AlignLeftOutlined:
      return (await __webpack_require__.e(/* import() */ 15976).then(__webpack_require__.bind(__webpack_require__, 315976))).default;
    case ICON_PROP_KEY.AlignRightOutlined:
      return (await __webpack_require__.e(/* import() */ 56423).then(__webpack_require__.bind(__webpack_require__, 756423))).default;
    case ICON_PROP_KEY.AlignBottomSpaceOutlined:
      return (await __webpack_require__.e(/* import() */ 95565).then(__webpack_require__.bind(__webpack_require__, 595565))).default;
    case ICON_PROP_KEY.AlignHorizontalSpaceOutlined:
      return (await __webpack_require__.e(/* import() */ 82957).then(__webpack_require__.bind(__webpack_require__, 382957))).default;
    case ICON_PROP_KEY.AlignLeftSpaceOutlined:
      return (await __webpack_require__.e(/* import() */ 39319).then(__webpack_require__.bind(__webpack_require__, 239319))).default;
    case ICON_PROP_KEY.AlignRightSpaceOutlined:
      return (await __webpack_require__.e(/* import() */ 89202).then(__webpack_require__.bind(__webpack_require__, 589202))).default;
    case ICON_PROP_KEY.AlignTopSpaceOutlined:
      return (await __webpack_require__.e(/* import() */ 27458).then(__webpack_require__.bind(__webpack_require__, 27458))).default;
    case ICON_PROP_KEY.AlignVerticalSpaceOutlined:
      return (await __webpack_require__.e(/* import() */ 82008).then(__webpack_require__.bind(__webpack_require__, 982008))).default;
    case ICON_PROP_KEY.ArrowUpOutlined:
      return (await __webpack_require__.e(/* import() */ 71934).then(__webpack_require__.bind(__webpack_require__, 71934))).default;
    case ICON_PROP_KEY.BackToTopOutlined:
      return (await __webpack_require__.e(/* import() */ 22586).then(__webpack_require__.bind(__webpack_require__, 722586))).default;
    case ICON_PROP_KEY.BackOutlined:
      return (await __webpack_require__.e(/* import() */ 356).then(__webpack_require__.bind(__webpack_require__, 400356))).default;
    case ICON_PROP_KEY.BagCheckmarkOutlined:
      return (await __webpack_require__.e(/* import() */ 83173).then(__webpack_require__.bind(__webpack_require__, 683173))).default;
    case ICON_PROP_KEY.BlockGroupOutlined:
      return (await __webpack_require__.e(/* import() */ 85683).then(__webpack_require__.bind(__webpack_require__, 85683))).default;
    case ICON_PROP_KEY.BoldOutlined:
      return (await __webpack_require__.e(/* import() */ 35507).then(__webpack_require__.bind(__webpack_require__, 935507))).default;
    case ICON_PROP_KEY.BookOutlined:
      return (await __webpack_require__.e(/* import() */ 60304).then(__webpack_require__.bind(__webpack_require__, 60304))).default;
    case ICON_PROP_KEY.BoxOutlined:
      return (await __webpack_require__.e(/* import() */ 27163).then(__webpack_require__.bind(__webpack_require__, 227163))).default;
    case ICON_PROP_KEY.BuildPcOutlined:
      return (await __webpack_require__.e(/* import() */ 87430).then(__webpack_require__.bind(__webpack_require__, 587430))).default;
    case ICON_PROP_KEY.BulletedListOutlined:
      return (await __webpack_require__.e(/* import() */ 5113).then(__webpack_require__.bind(__webpack_require__, 305113))).default;
    case ICON_PROP_KEY.BusinessCustomerOutlined:
      return (await __webpack_require__.e(/* import() */ 90380).then(__webpack_require__.bind(__webpack_require__, 590380))).default;
    case ICON_PROP_KEY.BusinessSolutionOutlined:
      return (await __webpack_require__.e(/* import() */ 63640).then(__webpack_require__.bind(__webpack_require__, 163640))).default;
    case ICON_PROP_KEY.ButtonOutlined:
      return (await __webpack_require__.e(/* import() */ 33924).then(__webpack_require__.bind(__webpack_require__, 33924))).default;
    case ICON_PROP_KEY.CalculatorOutlined:
      return (await __webpack_require__.e(/* import() */ 99719).then(__webpack_require__.bind(__webpack_require__, 499719))).default;
    case ICON_PROP_KEY.CalendarOutlined:
      return (await __webpack_require__.e(/* import() */ 69406).then(__webpack_require__.bind(__webpack_require__, 963728))).default;
    case ICON_PROP_KEY.CalendarWorkForWeekOutlined:
      return (await __webpack_require__.e(/* import() */ 16583).then(__webpack_require__.bind(__webpack_require__, 316583))).default;
    case ICON_PROP_KEY.CameraOutlined:
      return (await __webpack_require__.e(/* import() */ 85642).then(__webpack_require__.bind(__webpack_require__, 785642))).default;
    case ICON_PROP_KEY.CartOutlined:
      return (await __webpack_require__.e(/* import() */ 87818).then(__webpack_require__.bind(__webpack_require__, 287818))).default;
    case ICON_PROP_KEY.CartPlusOutlined:
      return (await __webpack_require__.e(/* import() */ 92223).then(__webpack_require__.bind(__webpack_require__, 992223))).default;
    case ICON_PROP_KEY.CartPlusFiveOutlined:
      return (await __webpack_require__.e(/* import() */ 90037).then(__webpack_require__.bind(__webpack_require__, 690037))).default;
    case ICON_PROP_KEY.CartPlusFourOutlined:
      return (await __webpack_require__.e(/* import() */ 47203).then(__webpack_require__.bind(__webpack_require__, 47203))).default;
    case ICON_PROP_KEY.CartPlusThreeOutlined:
      return (await __webpack_require__.e(/* import() */ 81036).then(__webpack_require__.bind(__webpack_require__, 781036))).default;
    case ICON_PROP_KEY.CartPlusTwoOutlined:
      return (await __webpack_require__.e(/* import() */ 91854).then(__webpack_require__.bind(__webpack_require__, 691854))).default;
    case ICON_PROP_KEY.CashOutlined:
      return (await __webpack_require__.e(/* import() */ 64057).then(__webpack_require__.bind(__webpack_require__, 564057))).default;
    case ICON_PROP_KEY.CautionOutlined:
      return (await __webpack_require__.e(/* import() */ 56276).then(__webpack_require__.bind(__webpack_require__, 956276))).default;
    case ICON_PROP_KEY.ChatOutlined:
      return (await __webpack_require__.e(/* import() */ 74296).then(__webpack_require__.bind(__webpack_require__, 574296))).default;
    case ICON_PROP_KEY.CheckOutlined:
      return (await __webpack_require__.e(/* import() */ 87531).then(__webpack_require__.bind(__webpack_require__, 687531))).default;
    case ICON_PROP_KEY.ChecklistOutlined:
      return (await __webpack_require__.e(/* import() */ 82518).then(__webpack_require__.bind(__webpack_require__, 482518))).default;
    case ICON_PROP_KEY.ChevronDownOutlined:
      return (await __webpack_require__.e(/* import() */ 9013).then(__webpack_require__.bind(__webpack_require__, 9013))).default;
    case ICON_PROP_KEY.ChevronUpOutlined:
      return (await __webpack_require__.e(/* import() */ 42407).then(__webpack_require__.bind(__webpack_require__, 342407))).default;
    case ICON_PROP_KEY.ChipOutlined:
      return (await __webpack_require__.e(/* import() */ 77100).then(__webpack_require__.bind(__webpack_require__, 777100))).default;
    case ICON_PROP_KEY.CircleBackOutlined:
      return (await __webpack_require__.e(/* import() */ 20908).then(__webpack_require__.bind(__webpack_require__, 20908))).default;
    case ICON_PROP_KEY.CircleDownOutlined:
      return (await __webpack_require__.e(/* import() */ 8261).then(__webpack_require__.bind(__webpack_require__, 608261))).default;
    case ICON_PROP_KEY.CircleForwardOutlined:
      return (await __webpack_require__.e(/* import() */ 10742).then(__webpack_require__.bind(__webpack_require__, 110742))).default;
    case ICON_PROP_KEY.CircleUpOutlined:
      return (await __webpack_require__.e(/* import() */ 1468).then(__webpack_require__.bind(__webpack_require__, 201468))).default;
    case ICON_PROP_KEY.CloseOutlined:
      return (await __webpack_require__.e(/* import() */ 43044).then(__webpack_require__.bind(__webpack_require__, 343044))).default;
    case ICON_PROP_KEY.CloudArrowUpOutlined:
      return (await __webpack_require__.e(/* import() */ 70450).then(__webpack_require__.bind(__webpack_require__, 970450))).default;
    case ICON_PROP_KEY.CodeOutlined:
      return (await __webpack_require__.e(/* import() */ 74894).then(__webpack_require__.bind(__webpack_require__, 74894))).default;
    case ICON_PROP_KEY.ColorSwitchOutlined:
      return (await __webpack_require__.e(/* import() */ 44283).then(__webpack_require__.bind(__webpack_require__, 244283))).default;
    case ICON_PROP_KEY.ContentSettingsOutlined:
      return (await __webpack_require__.e(/* import() */ 6914).then(__webpack_require__.bind(__webpack_require__, 106914))).default;
    case ICON_PROP_KEY.CopyOutlined:
      return (await __webpack_require__.e(/* import() */ 54270).then(__webpack_require__.bind(__webpack_require__, 554270))).default;
    case ICON_PROP_KEY.CustomerSupportOutlined:
      return (await __webpack_require__.e(/* import() */ 95820).then(__webpack_require__.bind(__webpack_require__, 95820))).default;
    case ICON_PROP_KEY.DataTreemapOutlined:
      return (await __webpack_require__.e(/* import() */ 18996).then(__webpack_require__.bind(__webpack_require__, 418996))).default;
    case ICON_PROP_KEY.DeleteOutlined:
      return (await __webpack_require__.e(/* import() */ 85192).then(__webpack_require__.bind(__webpack_require__, 985192))).default;
    case ICON_PROP_KEY.DeleteColumnOutlined:
      return (await __webpack_require__.e(/* import() */ 45422).then(__webpack_require__.bind(__webpack_require__, 945422))).default;
    case ICON_PROP_KEY.DeleteRowOutlined:
      return (await __webpack_require__.e(/* import() */ 91506).then(__webpack_require__.bind(__webpack_require__, 491506))).default;
    case ICON_PROP_KEY.DesktopOutlined:
      return (await __webpack_require__.e(/* import() */ 81413).then(__webpack_require__.bind(__webpack_require__, 681413))).default;
    case ICON_PROP_KEY.DinoOutlined:
      return (await __webpack_require__.e(/* import() */ 90586).then(__webpack_require__.bind(__webpack_require__, 390586))).default;
    case ICON_PROP_KEY.DiscordOutlined:
      return (await __webpack_require__.e(/* import() */ 10048).then(__webpack_require__.bind(__webpack_require__, 210048))).default;
    case ICON_PROP_KEY.DiscountTagOutlined:
      return (await __webpack_require__.e(/* import() */ 69079).then(__webpack_require__.bind(__webpack_require__, 169079))).default;
    case ICON_PROP_KEY.DiscountOutlined:
      return (await __webpack_require__.e(/* import() */ 8603).then(__webpack_require__.bind(__webpack_require__, 408603))).default;
    case ICON_PROP_KEY.DividerOutlined:
      return (await __webpack_require__.e(/* import() */ 82469).then(__webpack_require__.bind(__webpack_require__, 482469))).default;
    case ICON_PROP_KEY.DocumentOutlined:
      return (await __webpack_require__.e(/* import() */ 80675).then(__webpack_require__.bind(__webpack_require__, 980675))).default;
    case ICON_PROP_KEY.DotOutlined:
      return (await __webpack_require__.e(/* import() */ 93720).then(__webpack_require__.bind(__webpack_require__, 693720))).default;
    case ICON_PROP_KEY.DownLineOutlined:
      return (await __webpack_require__.e(/* import() */ 60356).then(__webpack_require__.bind(__webpack_require__, 60356))).default;
    case ICON_PROP_KEY.DownOutlined:
      return (await __webpack_require__.e(/* import() */ 40448).then(__webpack_require__.bind(__webpack_require__, 840448))).default;
    case ICON_PROP_KEY.DownloadOutlined:
      return (await __webpack_require__.e(/* import() */ 61998).then(__webpack_require__.bind(__webpack_require__, 961998))).default;
    case ICON_PROP_KEY.DownloadLightOutlined:
      return (await __webpack_require__.e(/* import() */ 1206).then(__webpack_require__.bind(__webpack_require__, 301206))).default;
    case ICON_PROP_KEY.DragOutlined:
      return (await __webpack_require__.e(/* import() */ 6718).then(__webpack_require__.bind(__webpack_require__, 806718))).default;
    case ICON_PROP_KEY.DragdropOutlined:
      return (await __webpack_require__.e(/* import() */ 98601).then(__webpack_require__.bind(__webpack_require__, 798601))).default;
    case ICON_PROP_KEY.DuplicateOutlined:
      return (await __webpack_require__.e(/* import() */ 25683).then(__webpack_require__.bind(__webpack_require__, 375307))).default;
    case ICON_PROP_KEY.EditColumnOutlined:
      return (await __webpack_require__.e(/* import() */ 63658).then(__webpack_require__.bind(__webpack_require__, 863658))).default;
    case ICON_PROP_KEY.EditSquareOutlined:
      return (await __webpack_require__.e(/* import() */ 95084).then(__webpack_require__.bind(__webpack_require__, 795084))).default;
    case ICON_PROP_KEY.EditOutlined:
      return (await __webpack_require__.e(/* import() */ 73245).then(__webpack_require__.bind(__webpack_require__, 73245))).default;
    case ICON_PROP_KEY.EndShiftOutlined:
      return (await __webpack_require__.e(/* import() */ 6463).then(__webpack_require__.bind(__webpack_require__, 806463))).default;
    case ICON_PROP_KEY.ExportFileOutlined:
      return (await __webpack_require__.e(/* import() */ 22923).then(__webpack_require__.bind(__webpack_require__, 522923))).default;
    case ICON_PROP_KEY.EyeOutlined:
      return (await __webpack_require__.e(/* import() */ 21875).then(__webpack_require__.bind(__webpack_require__, 421875))).default;
    case ICON_PROP_KEY.FaceIdOutlined:
      return (await __webpack_require__.e(/* import() */ 10305).then(__webpack_require__.bind(__webpack_require__, 710305))).default;
    case ICON_PROP_KEY.FileOutlined:
      return (await __webpack_require__.e(/* import() */ 2409).then(__webpack_require__.bind(__webpack_require__, 602409))).default;
    case ICON_PROP_KEY.FillColorShapeOutlined:
      return (await __webpack_require__.e(/* import() */ 92344).then(__webpack_require__.bind(__webpack_require__, 792344))).default;
    case ICON_PROP_KEY.FillColorTextOutlined:
      return (await __webpack_require__.e(/* import() */ 86817).then(__webpack_require__.bind(__webpack_require__, 486817))).default;
    case ICON_PROP_KEY.FilterOutlined:
      return (await __webpack_require__.e(/* import() */ 24682).then(__webpack_require__.bind(__webpack_require__, 424682))).default;
    case ICON_PROP_KEY.FingerPrintOutlined:
      return (await __webpack_require__.e(/* import() */ 92902).then(__webpack_require__.bind(__webpack_require__, 692902))).default;
    case ICON_PROP_KEY.FluentButtonOutlined:
      return (await __webpack_require__.e(/* import() */ 74187).then(__webpack_require__.bind(__webpack_require__, 674187))).default;
    case ICON_PROP_KEY.FluentLinkOutlined:
      return (await __webpack_require__.e(/* import() */ 2543).then(__webpack_require__.bind(__webpack_require__, 502543))).default;
    case ICON_PROP_KEY.FormOutlined:
      return (await __webpack_require__.e(/* import() */ 70593).then(__webpack_require__.bind(__webpack_require__, 770593))).default;
    case ICON_PROP_KEY.FormatTextLeftOutlined:
      return (await __webpack_require__.e(/* import() */ 76315).then(__webpack_require__.bind(__webpack_require__, 476315))).default;
    case ICON_PROP_KEY.FormatTextRightOutlined:
      return (await __webpack_require__.e(/* import() */ 51142).then(__webpack_require__.bind(__webpack_require__, 651142))).default;
    case ICON_PROP_KEY.ForwardOutlined:
      return (await __webpack_require__.e(/* import() */ 63823).then(__webpack_require__.bind(__webpack_require__, 763823))).default;
    case ICON_PROP_KEY.FourPointSpacingOutlined:
      return (await __webpack_require__.e(/* import() */ 14852).then(__webpack_require__.bind(__webpack_require__, 814852))).default;
    case ICON_PROP_KEY.GamingOutlined:
      return (await __webpack_require__.e(/* import() */ 92408).then(__webpack_require__.bind(__webpack_require__, 192408))).default;
    case ICON_PROP_KEY.GarbageOutlined:
      return (await __webpack_require__.e(/* import() */ 79296).then(__webpack_require__.bind(__webpack_require__, 679296))).default;
    case ICON_PROP_KEY.GoldOutlined:
      return (await __webpack_require__.e(/* import() */ 7186).then(__webpack_require__.bind(__webpack_require__, 607186))).default;
    case ICON_PROP_KEY.GuaranteeCheckedOutlined:
      return (await __webpack_require__.e(/* import() */ 66780).then(__webpack_require__.bind(__webpack_require__, 566780))).default;
    case ICON_PROP_KEY.HamburgerOutlined:
      return (await __webpack_require__.e(/* import() */ 34578).then(__webpack_require__.bind(__webpack_require__, 534578))).default;
    case ICON_PROP_KEY.HeaderOutlined:
      return (await __webpack_require__.e(/* import() */ 95814).then(__webpack_require__.bind(__webpack_require__, 695814))).default;
    case ICON_PROP_KEY.HeadingOutlined:
      return (await __webpack_require__.e(/* import() */ 10970).then(__webpack_require__.bind(__webpack_require__, 710970))).default;
    case ICON_PROP_KEY.HeadphoneOutlined:
      return (await __webpack_require__.e(/* import() */ 80368).then(__webpack_require__.bind(__webpack_require__, 580368))).default;
    case ICON_PROP_KEY.HideOutlined:
      return (await __webpack_require__.e(/* import() */ 68765).then(__webpack_require__.bind(__webpack_require__, 368765))).default;
    case ICON_PROP_KEY.HOneOutlined:
      return (await __webpack_require__.e(/* import() */ 67157).then(__webpack_require__.bind(__webpack_require__, 867157))).default;
    case ICON_PROP_KEY.HThreeOutlined:
      return (await __webpack_require__.e(/* import() */ 16605).then(__webpack_require__.bind(__webpack_require__, 416605))).default;
    case ICON_PROP_KEY.HTwoOutlined:
      return (await __webpack_require__.e(/* import() */ 15506).then(__webpack_require__.bind(__webpack_require__, 215506))).default;
    case ICON_PROP_KEY.IdCardOutlined:
      return (await __webpack_require__.e(/* import() */ 45556).then(__webpack_require__.bind(__webpack_require__, 645556))).default;
    case ICON_PROP_KEY.ImageOutlined:
      return (await __webpack_require__.e(/* import() */ 53745).then(__webpack_require__.bind(__webpack_require__, 853745))).default;
    case ICON_PROP_KEY.InforOutlined:
      return (await __webpack_require__.e(/* import() */ 14607).then(__webpack_require__.bind(__webpack_require__, 814607))).default;
    case ICON_PROP_KEY.InsertColumnAfterOutlined:
      return (await __webpack_require__.e(/* import() */ 26838).then(__webpack_require__.bind(__webpack_require__, 726838))).default;
    case ICON_PROP_KEY.InsertColumnBeforeOutlined:
      return (await __webpack_require__.e(/* import() */ 50920).then(__webpack_require__.bind(__webpack_require__, 850920))).default;
    case ICON_PROP_KEY.InsertRowAboveOutlined:
      return (await __webpack_require__.e(/* import() */ 1411).then(__webpack_require__.bind(__webpack_require__, 801411))).default;
    case ICON_PROP_KEY.InsertRowBelowOutlined:
      return (await __webpack_require__.e(/* import() */ 14720).then(__webpack_require__.bind(__webpack_require__, 14720))).default;
    case ICON_PROP_KEY.InstallmentOutlined:
      return (await __webpack_require__.e(/* import() */ 30894).then(__webpack_require__.bind(__webpack_require__, 530894))).default;
    case ICON_PROP_KEY.InstallmentCalendarOutlined:
      return (await __webpack_require__.e(/* import() */ 72666).then(__webpack_require__.bind(__webpack_require__, 872666))).default;
    case ICON_PROP_KEY.InternetOutlined:
      return (await __webpack_require__.e(/* import() */ 17202).then(__webpack_require__.bind(__webpack_require__, 617202))).default;
    case ICON_PROP_KEY.ItalicOutlined:
      return (await __webpack_require__.e(/* import() */ 54006).then(__webpack_require__.bind(__webpack_require__, 454006))).default;
    case ICON_PROP_KEY.JumpForwardOutlined:
      return (await __webpack_require__.e(/* import() */ 42737).then(__webpack_require__.bind(__webpack_require__, 542737))).default;
    case ICON_PROP_KEY.JumpBackOutlined:
      return (await __webpack_require__.e(/* import() */ 23530).then(__webpack_require__.bind(__webpack_require__, 423530))).default;
    case ICON_PROP_KEY.JumpForwardAlternativeOutlined:
      return (await __webpack_require__.e(/* import() */ 11773).then(__webpack_require__.bind(__webpack_require__, 511773))).default;
    case ICON_PROP_KEY.LeftLineOutlined:
      return (await __webpack_require__.e(/* import() */ 62916).then(__webpack_require__.bind(__webpack_require__, 862916))).default;
    case ICON_PROP_KEY.LeftOutlined:
      return (await __webpack_require__.e(/* import() */ 66905).then(__webpack_require__.bind(__webpack_require__, 366905))).default;
    case ICON_PROP_KEY.LineOutlined:
      return (await __webpack_require__.e(/* import() */ 44176).then(__webpack_require__.bind(__webpack_require__, 44176))).default;
    case ICON_PROP_KEY.LineDashedOutlined:
      return (await __webpack_require__.e(/* import() */ 93286).then(__webpack_require__.bind(__webpack_require__, 993286))).default;
    case ICON_PROP_KEY.LineDottedOutlined:
      return (await __webpack_require__.e(/* import() */ 65260).then(__webpack_require__.bind(__webpack_require__, 65260))).default;
    case ICON_PROP_KEY.LineThroughOutlined:
      return (await __webpack_require__.e(/* import() */ 80965).then(__webpack_require__.bind(__webpack_require__, 880965))).default;
    case ICON_PROP_KEY.LinkOutlined:
      return (await __webpack_require__.e(/* import() */ 73125).then(__webpack_require__.bind(__webpack_require__, 873125))).default;
    case ICON_PROP_KEY.ListLocationOutlined:
      return (await __webpack_require__.e(/* import() */ 84058).then(__webpack_require__.bind(__webpack_require__, 784058))).default;
    case ICON_PROP_KEY.ListOutlined:
      return (await __webpack_require__.e(/* import() */ 98517).then(__webpack_require__.bind(__webpack_require__, 198517))).default;
    case ICON_PROP_KEY.LocationOutlined:
      return (await __webpack_require__.e(/* import() */ 53249).then(__webpack_require__.bind(__webpack_require__, 553249))).default;
    case ICON_PROP_KEY.LockOutlined:
      return (await __webpack_require__.e(/* import() */ 24565).then(__webpack_require__.bind(__webpack_require__, 24565))).default;
    case ICON_PROP_KEY.LogOutOutlined:
      return (await __webpack_require__.e(/* import() */ 70295).then(__webpack_require__.bind(__webpack_require__, 770295))).default;
    case ICON_PROP_KEY.LoyaltyOutlined:
      return (await __webpack_require__.e(/* import() */ 62456).then(__webpack_require__.bind(__webpack_require__, 362456))).default;
    case ICON_PROP_KEY.MailOutlined:
      return (await __webpack_require__.e(/* import() */ 19319).then(__webpack_require__.bind(__webpack_require__, 619319))).default;
    case ICON_PROP_KEY.MenuOutlined:
      return (await __webpack_require__.e(/* import() */ 88133).then(__webpack_require__.bind(__webpack_require__, 288133))).default;
    case ICON_PROP_KEY.MinusCircleOutlined:
      return (await __webpack_require__.e(/* import() */ 46520).then(__webpack_require__.bind(__webpack_require__, 846520))).default;
    case ICON_PROP_KEY.MinusRetangleOutlined:
      return (await __webpack_require__.e(/* import() */ 65607).then(__webpack_require__.bind(__webpack_require__, 65607))).default;
    case ICON_PROP_KEY.MinusOutlined:
      return (await __webpack_require__.e(/* import() */ 37275).then(__webpack_require__.bind(__webpack_require__, 837275))).default;
    case ICON_PROP_KEY.MobileAndDesktopOutlined:
      return (await __webpack_require__.e(/* import() */ 36883).then(__webpack_require__.bind(__webpack_require__, 536883))).default;
    case ICON_PROP_KEY.MobiphoneOutlined:
      return (await __webpack_require__.e(/* import() */ 58953).then(__webpack_require__.bind(__webpack_require__, 958953))).default;
    case ICON_PROP_KEY.MoneyTransferOutlined:
      return (await __webpack_require__.e(/* import() */ 5237).then(__webpack_require__.bind(__webpack_require__, 905237))).default;
    case ICON_PROP_KEY.MonitorOutlined:
      return (await __webpack_require__.e(/* import() */ 2823).then(__webpack_require__.bind(__webpack_require__, 602823))).default;
    case ICON_PROP_KEY.MoreInforOutlined:
      return (await __webpack_require__.e(/* import() */ 9015).then(__webpack_require__.bind(__webpack_require__, 909015))).default;
    case ICON_PROP_KEY.MoreProductOutlined:
      return (await __webpack_require__.e(/* import() */ 33354).then(__webpack_require__.bind(__webpack_require__, 633354))).default;
    case ICON_PROP_KEY.NewsOutlined:
      return (await __webpack_require__.e(/* import() */ 39876).then(__webpack_require__.bind(__webpack_require__, 839876))).default;
    case ICON_PROP_KEY.NoneOutlined:
      return (await __webpack_require__.e(/* import() */ 32538).then(__webpack_require__.bind(__webpack_require__, 532538))).default;
    case ICON_PROP_KEY.NotFoundOutlined:
      return (await __webpack_require__.e(/* import() */ 87410).then(__webpack_require__.bind(__webpack_require__, 287410))).default;
    case ICON_PROP_KEY.NotificationsOutlined:
      return (await __webpack_require__.e(/* import() */ 26707).then(__webpack_require__.bind(__webpack_require__, 726707))).default;
    case ICON_PROP_KEY.NumberedListOutlined:
      return (await __webpack_require__.e(/* import() */ 49202).then(__webpack_require__.bind(__webpack_require__, 449202))).default;
    case ICON_PROP_KEY.OrderOutlined:
      return (await __webpack_require__.e(/* import() */ 60584).then(__webpack_require__.bind(__webpack_require__, 460584))).default;
    case ICON_PROP_KEY.PageOutlined:
      return (await __webpack_require__.e(/* import() */ 60158).then(__webpack_require__.bind(__webpack_require__, 960158))).default;
    case ICON_PROP_KEY.ParagraphOutlined:
      return (await __webpack_require__.e(/* import() */ 57228).then(__webpack_require__.bind(__webpack_require__, 757228))).default;
    case ICON_PROP_KEY.PauseOutlined:
      return (await __webpack_require__.e(/* import() */ 50528).then(__webpack_require__.bind(__webpack_require__, 450528))).default;
    case ICON_PROP_KEY.PauseIconOutlined:
      return (await __webpack_require__.e(/* import() */ 98209).then(__webpack_require__.bind(__webpack_require__, 798209))).default;
    case ICON_PROP_KEY.PaymentOutlined:
      return (await __webpack_require__.e(/* import() */ 76059).then(__webpack_require__.bind(__webpack_require__, 776059))).default;
    case ICON_PROP_KEY.PbArrowLeftOutlined:
      return (await __webpack_require__.e(/* import() */ 16719).then(__webpack_require__.bind(__webpack_require__, 16719))).default;
    case ICON_PROP_KEY.PbLinkOutlined:
      return (await __webpack_require__.e(/* import() */ 34185).then(__webpack_require__.bind(__webpack_require__, 834185))).default;
    case ICON_PROP_KEY.PbUnlinkOutlined:
      return (await __webpack_require__.e(/* import() */ 46559).then(__webpack_require__.bind(__webpack_require__, 346559))).default;
    case ICON_PROP_KEY.PcOutlined:
      return (await __webpack_require__.e(/* import() */ 11802).then(__webpack_require__.bind(__webpack_require__, 111802))).default;
    case ICON_PROP_KEY.PhoneOutlined:
      return (await __webpack_require__.e(/* import() */ 15939).then(__webpack_require__.bind(__webpack_require__, 915939))).default;
    case ICON_PROP_KEY.PlayOutlined:
      return (await __webpack_require__.e(/* import() */ 76829).then(__webpack_require__.bind(__webpack_require__, 876829))).default;
    case ICON_PROP_KEY.PlayBadgeOutlineOutlined:
      return (await __webpack_require__.e(/* import() */ 55159).then(__webpack_require__.bind(__webpack_require__, 555159))).default;
    case ICON_PROP_KEY.PlayBoldOutlineOutlined:
      return (await __webpack_require__.e(/* import() */ 89257).then(__webpack_require__.bind(__webpack_require__, 189257))).default;
    case ICON_PROP_KEY.PlayCircleBoldOutlineOutlined:
      return (await __webpack_require__.e(/* import() */ 33320).then(__webpack_require__.bind(__webpack_require__, 733320))).default;
    case ICON_PROP_KEY.PlayCircleOutlineOutlined:
      return (await __webpack_require__.e(/* import() */ 44650).then(__webpack_require__.bind(__webpack_require__, 144650))).default;
    case ICON_PROP_KEY.PlayRoundedSquareOutlineOutlined:
      return (await __webpack_require__.e(/* import() */ 44566).then(__webpack_require__.bind(__webpack_require__, 444566))).default;
    case ICON_PROP_KEY.PlusCircleOutlined:
      return (await __webpack_require__.e(/* import() */ 15046).then(__webpack_require__.bind(__webpack_require__, 915046))).default;
    case ICON_PROP_KEY.PlusRetangleOutlined:
      return (await __webpack_require__.e(/* import() */ 43209).then(__webpack_require__.bind(__webpack_require__, 43209))).default;
    case ICON_PROP_KEY.PopupOutlined:
      return (await __webpack_require__.e(/* import() */ 44141).then(__webpack_require__.bind(__webpack_require__, 44141))).default;
    case ICON_PROP_KEY.PrinterOutlined:
      return (await __webpack_require__.e(/* import() */ 32056).then(__webpack_require__.bind(__webpack_require__, 532056))).default;
    case ICON_PROP_KEY.ProductOutlined:
      return (await __webpack_require__.e(/* import() */ 61844).then(__webpack_require__.bind(__webpack_require__, 761844))).default;
    case ICON_PROP_KEY.ProfileOutlined:
      return (await __webpack_require__.e(/* import() */ 67780).then(__webpack_require__.bind(__webpack_require__, 167780))).default;
    case ICON_PROP_KEY.PromoOutlined:
      return (await __webpack_require__.e(/* import() */ 64944).then(__webpack_require__.bind(__webpack_require__, 464944))).default;
    case ICON_PROP_KEY.PromoDiscountOutlined:
      return (await __webpack_require__.e(/* import() */ 32629).then(__webpack_require__.bind(__webpack_require__, 732629))).default;
    case ICON_PROP_KEY.QaOutlined:
      return (await __webpack_require__.e(/* import() */ 86930).then(__webpack_require__.bind(__webpack_require__, 486930))).default;
    case ICON_PROP_KEY.QrCodeScanOutlined:
      return (await __webpack_require__.e(/* import() */ 51472).then(__webpack_require__.bind(__webpack_require__, 651472))).default;
    case ICON_PROP_KEY.RadiusBottomLeftOutlined:
      return (await __webpack_require__.e(/* import() */ 23204).then(__webpack_require__.bind(__webpack_require__, 123204))).default;
    case ICON_PROP_KEY.RadiusBottomRightOutlined:
      return (await __webpack_require__.e(/* import() */ 18601).then(__webpack_require__.bind(__webpack_require__, 18601))).default;
    case ICON_PROP_KEY.RadiusUpLeftOutlined:
      return (await __webpack_require__.e(/* import() */ 95935).then(__webpack_require__.bind(__webpack_require__, 895935))).default;
    case ICON_PROP_KEY.RadiusUpRightOutlined:
      return (await __webpack_require__.e(/* import() */ 40895).then(__webpack_require__.bind(__webpack_require__, 640895))).default;
    case ICON_PROP_KEY.RamOutlined:
      return (await __webpack_require__.e(/* import() */ 71246).then(__webpack_require__.bind(__webpack_require__, 971246))).default;
    case ICON_PROP_KEY.RedoOutlined:
      return (await __webpack_require__.e(/* import() */ 20032).then(__webpack_require__.bind(__webpack_require__, 720032))).default;
    case ICON_PROP_KEY.RefreshOutlined:
      return (await __webpack_require__.e(/* import() */ 24035).then(__webpack_require__.bind(__webpack_require__, 224035))).default;
    case ICON_PROP_KEY.RefundOutlined:
      return (await __webpack_require__.e(/* import() */ 26208).then(__webpack_require__.bind(__webpack_require__, 426208))).default;
    case ICON_PROP_KEY.ResizeSmallOutlined:
      return (await __webpack_require__.e(/* import() */ 924).then(__webpack_require__.bind(__webpack_require__, 800924))).default;
    case ICON_PROP_KEY.ReturnItemOutlined:
      return (await __webpack_require__.e(/* import() */ 93346).then(__webpack_require__.bind(__webpack_require__, 993346))).default;
    case ICON_PROP_KEY.RightLineOutlined:
      return (await __webpack_require__.e(/* import() */ 40524).then(__webpack_require__.bind(__webpack_require__, 740524))).default;
    case ICON_PROP_KEY.RightOutlined:
      return (await __webpack_require__.e(/* import() */ 44090).then(__webpack_require__.bind(__webpack_require__, 544090))).default;
    case ICON_PROP_KEY.RowTripleOutlined:
      return (await __webpack_require__.e(/* import() */ 47697).then(__webpack_require__.bind(__webpack_require__, 647697))).default;
    case ICON_PROP_KEY.SaveOutlined:
      return (await __webpack_require__.e(/* import() */ 82178).then(__webpack_require__.bind(__webpack_require__, 682178))).default;
    case ICON_PROP_KEY.ScalesOutlined:
      return (await __webpack_require__.e(/* import() */ 17967).then(__webpack_require__.bind(__webpack_require__, 317967))).default;
    case ICON_PROP_KEY.ScanningOutlined:
      return (await __webpack_require__.e(/* import() */ 54844).then(__webpack_require__.bind(__webpack_require__, 454844))).default;
    case ICON_PROP_KEY.SearchOutlined:
      return (await __webpack_require__.e(/* import() */ 33408).then(__webpack_require__.bind(__webpack_require__, 433408))).default;
    case ICON_PROP_KEY.SelectedOutlined:
      return (await __webpack_require__.e(/* import() */ 10572).then(__webpack_require__.bind(__webpack_require__, 10572))).default;
    case ICON_PROP_KEY.SettingsOutlined:
      return (await __webpack_require__.e(/* import() */ 90629).then(__webpack_require__.bind(__webpack_require__, 990629))).default;
    case ICON_PROP_KEY.ShareOutlined:
      return (await __webpack_require__.e(/* import() */ 23997).then(__webpack_require__.bind(__webpack_require__, 523997))).default;
    case ICON_PROP_KEY.ShieldOutlined:
      return (await __webpack_require__.e(/* import() */ 12834).then(__webpack_require__.bind(__webpack_require__, 712834))).default;
    case ICON_PROP_KEY.ShippingOutlined:
      return (await __webpack_require__.e(/* import() */ 28569).then(__webpack_require__.bind(__webpack_require__, 128569))).default;
    case ICON_PROP_KEY.ShopOutlined:
      return (await __webpack_require__.e(/* import() */ 40041).then(__webpack_require__.bind(__webpack_require__, 340041))).default;
    case ICON_PROP_KEY.ShoppingCartOutlined:
      return (await __webpack_require__.e(/* import() */ 49445).then(__webpack_require__.bind(__webpack_require__, 849445))).default;
    case ICON_PROP_KEY.ShortingOutlined:
      return (await __webpack_require__.e(/* import() */ 31713).then(__webpack_require__.bind(__webpack_require__, 431713))).default;
    case ICON_PROP_KEY.ShowOutlined:
      return (await __webpack_require__.e(/* import() */ 18138).then(__webpack_require__.bind(__webpack_require__, 318138))).default;
    case ICON_PROP_KEY.ShowroomOutlined:
      return (await __webpack_require__.e(/* import() */ 29912).then(__webpack_require__.bind(__webpack_require__, 29912))).default;
    case ICON_PROP_KEY.SlideTextOutlined:
      return (await __webpack_require__.e(/* import() */ 79685).then(__webpack_require__.bind(__webpack_require__, 79685))).default;
    case ICON_PROP_KEY.SpacerOutlined:
      return (await __webpack_require__.e(/* import() */ 7111).then(__webpack_require__.bind(__webpack_require__, 7111))).default;
    case ICON_PROP_KEY.SpeakerOutlined:
      return (await __webpack_require__.e(/* import() */ 65341).then(__webpack_require__.bind(__webpack_require__, 665341))).default;
    case ICON_PROP_KEY.SplitHorizontalOutlined:
      return (await __webpack_require__.e(/* import() */ 5339).then(__webpack_require__.bind(__webpack_require__, 305339))).default;
    case ICON_PROP_KEY.SquareMultipleOutlined:
      return (await __webpack_require__.e(/* import() */ 85262).then(__webpack_require__.bind(__webpack_require__, 85262))).default;
    case ICON_PROP_KEY.StarEmphasisOutlined:
      return (await __webpack_require__.e(/* import() */ 47229).then(__webpack_require__.bind(__webpack_require__, 247229))).default;
    case ICON_PROP_KEY.StopOutlined:
      return (await __webpack_require__.e(/* import() */ 60444).then(__webpack_require__.bind(__webpack_require__, 660444))).default;
    case ICON_PROP_KEY.SwitchOutlined:
      return (await __webpack_require__.e(/* import() */ 31237).then(__webpack_require__.bind(__webpack_require__, 31237))).default;
    case ICON_PROP_KEY.SyncOutlined:
      return (await __webpack_require__.e(/* import() */ 72422).then(__webpack_require__.bind(__webpack_require__, 472422))).default;
    case ICON_PROP_KEY.TabOutlined:
      return (await __webpack_require__.e(/* import() */ 93221).then(__webpack_require__.bind(__webpack_require__, 393221))).default;
    case ICON_PROP_KEY.TableOutlined:
      return (await __webpack_require__.e(/* import() */ 20643).then(__webpack_require__.bind(__webpack_require__, 320643))).default;
    case ICON_PROP_KEY.TableCellEditOutlined:
      return (await __webpack_require__.e(/* import() */ 50906).then(__webpack_require__.bind(__webpack_require__, 450906))).default;
    case ICON_PROP_KEY.TableCellMergeOutlined:
      return (await __webpack_require__.e(/* import() */ 83572).then(__webpack_require__.bind(__webpack_require__, 283572))).default;
    case ICON_PROP_KEY.TableCellSplitOutlined:
      return (await __webpack_require__.e(/* import() */ 71371).then(__webpack_require__.bind(__webpack_require__, 771371))).default;
    case ICON_PROP_KEY.TableSettingOutlined:
      return (await __webpack_require__.e(/* import() */ 32701).then(__webpack_require__.bind(__webpack_require__, 632701))).default;
    case ICON_PROP_KEY.TabletOutlined:
      return (await __webpack_require__.e(/* import() */ 75777).then(__webpack_require__.bind(__webpack_require__, 375777))).default;
    case ICON_PROP_KEY.TelephoneOutlined:
      return (await __webpack_require__.e(/* import() */ 88538).then(__webpack_require__.bind(__webpack_require__, 688538))).default;
    case ICON_PROP_KEY.TemplateOutlined:
      return (await __webpack_require__.e(/* import() */ 78228).then(__webpack_require__.bind(__webpack_require__, 578228))).default;
    case ICON_PROP_KEY.TestimonialOutlined:
      return (await __webpack_require__.e(/* import() */ 90039).then(__webpack_require__.bind(__webpack_require__, 190039))).default;
    case ICON_PROP_KEY.TextOutlined:
      return (await __webpack_require__.e(/* import() */ 63341).then(__webpack_require__.bind(__webpack_require__, 863341))).default;
    case ICON_PROP_KEY.TextExpandOutlined:
      return (await __webpack_require__.e(/* import() */ 27174).then(__webpack_require__.bind(__webpack_require__, 827174))).default;
    case ICON_PROP_KEY.TextUppercaseOutlined:
      return (await __webpack_require__.e(/* import() */ 20338).then(__webpack_require__.bind(__webpack_require__, 720338))).default;
    case ICON_PROP_KEY.TiviOutlined:
      return (await __webpack_require__.e(/* import() */ 31299).then(__webpack_require__.bind(__webpack_require__, 831299))).default;
    case ICON_PROP_KEY.TransactionHistoryOutlined:
      return (await __webpack_require__.e(/* import() */ 79730).then(__webpack_require__.bind(__webpack_require__, 79730))).default;
    case ICON_PROP_KEY.TrashBinDeleteRemoveOutlined:
      return (await __webpack_require__.e(/* import() */ 58820).then(__webpack_require__.bind(__webpack_require__, 858820))).default;
    case ICON_PROP_KEY.TreeviewOutlined:
      return (await __webpack_require__.e(/* import() */ 73015).then(__webpack_require__.bind(__webpack_require__, 873015))).default;
    case ICON_PROP_KEY.TvNewOutlined:
      return (await __webpack_require__.e(/* import() */ 68429).then(__webpack_require__.bind(__webpack_require__, 568429))).default;
    case ICON_PROP_KEY.TwoColumnsLayoutOutlined:
      return (await __webpack_require__.e(/* import() */ 89532).then(__webpack_require__.bind(__webpack_require__, 789532))).default;
    case ICON_PROP_KEY.UncheckedCheckboxOutlined:
      return (await __webpack_require__.e(/* import() */ 82855).then(__webpack_require__.bind(__webpack_require__, 782855))).default;
    case ICON_PROP_KEY.UnderlineOutlined:
      return (await __webpack_require__.e(/* import() */ 39044).then(__webpack_require__.bind(__webpack_require__, 839044))).default;
    case ICON_PROP_KEY.UndoOutlined:
      return (await __webpack_require__.e(/* import() */ 10614).then(__webpack_require__.bind(__webpack_require__, 710614))).default;
    case ICON_PROP_KEY.UnionPaymentOutlined:
      return (await __webpack_require__.e(/* import() */ 89200).then(__webpack_require__.bind(__webpack_require__, 689200))).default;
    case ICON_PROP_KEY.UnlinkOutlined:
      return (await __webpack_require__.e(/* import() */ 33380).then(__webpack_require__.bind(__webpack_require__, 633380))).default;
    case ICON_PROP_KEY.UnlockOutlined:
      return (await __webpack_require__.e(/* import() */ 1705).then(__webpack_require__.bind(__webpack_require__, 801705))).default;
    case ICON_PROP_KEY.UpLineOutlined:
      return (await __webpack_require__.e(/* import() */ 9664).then(__webpack_require__.bind(__webpack_require__, 209664))).default;
    case ICON_PROP_KEY.UpOutlined:
      return (await __webpack_require__.e(/* import() */ 65682).then(__webpack_require__.bind(__webpack_require__, 865682))).default;
    case ICON_PROP_KEY.UploadOutlined:
      return (await __webpack_require__.e(/* import() */ 6727).then(__webpack_require__.bind(__webpack_require__, 306727))).default;
    case ICON_PROP_KEY.VerticalLineOutlined:
      return (await __webpack_require__.e(/* import() */ 61967).then(__webpack_require__.bind(__webpack_require__, 861967))).default;
    case ICON_PROP_KEY.VideoClipOutlined:
      return (await __webpack_require__.e(/* import() */ 97887).then(__webpack_require__.bind(__webpack_require__, 297887))).default;
    case ICON_PROP_KEY.VoucherOutlined:
      return (await __webpack_require__.e(/* import() */ 75605).then(__webpack_require__.bind(__webpack_require__, 175605))).default;
    case ICON_PROP_KEY.WarehouseOutlined:
      return (await __webpack_require__.e(/* import() */ 58688).then(__webpack_require__.bind(__webpack_require__, 358688))).default;
    case ICON_PROP_KEY.WashingOutlined:
      return (await __webpack_require__.e(/* import() */ 55853).then(__webpack_require__.bind(__webpack_require__, 155853))).default;
    case ICON_PROP_KEY.WebcamOutlined:
      return (await __webpack_require__.e(/* import() */ 76521).then(__webpack_require__.bind(__webpack_require__, 476521))).default;
  }
};



// EXTERNAL MODULE: ../../.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/index.js
var react = __webpack_require__(891987);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@tempi-icons-virtual-6cb7d71704/0/cache/@tempi-icons-npm-1.6.1-UX4BUYER-8801.0-ca37e8c69f-e623acf0ec.zip/node_modules/@tempi/icons/dist/hooks/useIntersectionObserver.es.js


const useIntersectionObserver = (elementRef, {
  threshold = 0,
  root = null,
  rootMargin = "0%",
  freezeOnceVisible = false
}) => {
  const [isIntersected, setIsIntersected] = (0,react.useState)(false);
  const frozen = isIntersected && freezeOnceVisible;
  (0,react.useEffect)(() => {
    const node = elementRef == null ? void 0 : elementRef.current;
    const hasIOSupport = !!window.IntersectionObserver;
    if (!hasIOSupport || frozen || !node)
      return;
    const observerParams = { threshold, root, rootMargin };
    const observer = new IntersectionObserver(([entry], observer2) => {
      if (entry.isIntersecting) {
        setIsIntersected(true);
        if (freezeOnceVisible) {
          observer2.disconnect();
        }
      } else {
        setIsIntersected(false);
      }
    }, observerParams);
    observer.observe(node);
    return () => observer.disconnect();
  }, [elementRef == null ? void 0 : elementRef.current, threshold, root, rootMargin, frozen]);
  return isIntersected;
};



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@tempi-icons-virtual-6cb7d71704/0/cache/@tempi-icons-npm-1.6.1-UX4BUYER-8801.0-ca37e8c69f-e623acf0ec.zip/node_modules/@tempi/icons/dist/hooks/useIcon.es.js



const useIcon = (name, isVisible) => {
  const [error, setError] = (0,react.useState)(null);
  const [currIcon, setCurrIcon] = (0,react.useState)(null);
  (0,react.useEffect)(() => {
    const fetchImage = async () => {
      if (!isVisible || !name)
        return;
      try {
        const resIcon = await getIconUrl(name);
        if (!resIcon)
          throw new Error("icon notFound");
        if (resIcon !== currIcon)
          setCurrIcon(resIcon);
      } catch (err) {
        setError(err);
      }
    };
    fetchImage();
  }, [name, isVisible]);
  return {
    error,
    icon: currIcon
  };
};



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@tempi-icons-virtual-6cb7d71704/0/cache/@tempi-icons-npm-1.6.1-UX4BUYER-8801.0-ca37e8c69f-e623acf0ec.zip/node_modules/@tempi/icons/dist/base-components/IconBase.es.js




var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const InnerIcon = (props, ref) => {
  const _a = props, { name, style } = _a, rest = __objRest(_a, ["name", "style"]);
  const fallbackRef = (0,react.useRef)(null);
  const iconRef = ref || fallbackRef;
  const isVisible = useIntersectionObserver(iconRef, {});
  const { icon, error } = useIcon(name, isVisible);
  if (!name)
    return null;
  if (error)
    return /* @__PURE__ */ react.createElement("span", {
      style: { fontSize: (style == null ? void 0 : style.fontSize) || "1em" }
    }, "\u2757");
  const isColorIcon = ["Colored", "TwoTone", "Flags"].some(
    (el) => name.endsWith(el)
  );
  const getStyleNormalIcon = () => {
    const basicStyle = __spreadProps(__spreadValues({}, style), {
      display: "inline-block",
      width: (style == null ? void 0 : style.fontSize) || "1em",
      height: (style == null ? void 0 : style.fontSize) || "1em",
      WebkitMaskSize: "contain",
      WebkitMaskRepeat: "no-repeat",
      WebkitMaskPosition: "center",
      verticalAlign: "middle"
    });
    if (icon) {
      basicStyle.WebkitMaskImage = `url("${icon}")`;
      basicStyle.background = (style == null ? void 0 : style.color) || "currentColor";
    }
    return basicStyle;
  };
  const getStyleColorIcon = () => {
    style == null ? true : delete style.backgroundColor;
    const styleColor = __spreadProps(__spreadValues({}, style), {
      display: "inline-block",
      width: (style == null ? void 0 : style.fontSize) || "1em",
      height: (style == null ? void 0 : style.fontSize) || "1em",
      backgroundSize: (style == null ? void 0 : style.backgroundSize) || "contain",
      backgroundRepeat: "no-repeat",
      backgroundPosition: "center",
      verticalAlign: "middle"
    });
    if (icon)
      styleColor.backgroundImage = `url("${icon}")`;
    return styleColor;
  };
  return /* @__PURE__ */ react.createElement("span", __spreadValues({
    ref: iconRef,
    style: isColorIcon ? getStyleColorIcon() : getStyleNormalIcon()
  }, rest));
};
const Icon = react.forwardRef(InnerIcon);



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@tempi-icons-virtual-6cb7d71704/0/cache/@tempi-icons-npm-1.6.1-UX4BUYER-8801.0-ca37e8c69f-e623acf0ec.zip/node_modules/@tempi/icons/dist/index.es.js



const LIST_ICONS = Object.keys(ICON_PROP_KEY);




/***/ })

}]);